import {
    AfterContentInit,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    forwardRef,
    HostListener,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {AuthService} from '../../../shared/service/auth.service';
import {StudentService} from '../../../shared/service/student.service';
import {ConfigurationService} from '../../../shared/service/configuration.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {CreatorService} from '../../../shared/service/creator.service';
import {NavService} from '../../../shared/service/nav.service';
import {parse, stringify} from 'flatted';
import {ToastrService} from 'ngx-toastr';
import {ModalDismissReasons, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CommonService} from '../../../shared/service/common.service';
import {NewsubjectService} from '../../../shared/service/newsubject.service';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {CommonDataService} from '../../../shared/service/common-data.service';
import {TeacherService} from '../../../shared/service/teacher.service';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {EnvironmentService} from '../../../environment.service';
import {debounce} from 'lodash';
import {ContentdetailService} from '../../../shared/service/contentdetail.service';
import {ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexPlotOptions, ApexXAxis,
    ApexYAxis, ApexLegend} from 'ng-apexcharts';
import {urls} from '../../../shared/utils/urls';
import * as screenfull from 'screenfull';
import {Screenfull} from 'screenfull';

export interface TimeSpan {
    hours: number;
    minutes: number;
    seconds: number;
}

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    yaxis: ApexYAxis;
    plotOptions: ApexPlotOptions;
    dataLabels: ApexDataLabels;
    legend: ApexLegend;
};

declare const Desmos: any;

@Component({
    selector: 'app-answering',
    templateUrl: './answering.component.html',
    styleUrls: ['./answering.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => AnsweringComponent),
        multi: true,
    }],
})
export class AnsweringComponent implements OnInit, AfterContentInit, AfterViewInit {

    constructor(public auth: AuthService, public student: StudentService, public confi: ConfigurationService, public sanitizer: DomSanitizer, private modalService: NgbModal,
                public route: Router, public creator: CreatorService, public navServices: NavService, public toastr: ToastrService, public teacher: TeacherService,
                public common: CommonService, public content: ContentdetailService,
                public cdr: ChangeDetectorRef, public env: EnvironmentService,
                public commondata: CommonDataService,
                public newSubject: NewsubjectService, public router: ActivatedRoute) {
        this.getData = JSON.parse(this.auth.getSessionData('classDetails'));
        this.passageList();
        console.log(this.getData, 'getData');
        this.webhost = this.confi.getimgUrl();
        this.button = 'Hide PDF';
        // this.signaturePad.clear();
        this.delAnnotation = false;
        this.answerPatch = false;
        this.queries = '';
        this.queriesIndex = '';
    }

    get isSingleQnsWithFeedbackType(): boolean {
        return this.totalAns.length === 1 && this.totalAns.some(qns => qns.question_type_id === '55');
    }

    areaInfo: AreaInfo[] = [];
    public contentType: any;
    public questionData: any;
    public questionData1: any;
    public getData: any;
    public webhost: any;
    public pdfTemplate: any;
    public button: any;
    public totalFeedBack: any = '';
    public graphBoardValue: any;
    public settingList = [];
    public workAnnotate = [];
    public getGraph: any;
    public allowAutoScroll: any = true;
    public showAutoScroll: any = false;
    public expandPdf: any = false;
    public graphAnswerVal: any;
    public graphEditorAns: any = '';
    public uploadFileSize: any = 0;
    public workAreaId: any = 0;
    public workAreaIndex: any = 0;
    public graphFeedback = '';
    public graphEditorAnsDup: any;
    public graphId: any;
    public graphIndex: any;
    public scrolledPageNumber: any = 1;
    public queries: any;
    public sectionFilterVal: any = 'all';
    public queriesIndex: any;
    public downloadTemplate: any;
    public downloadTemplateName: any;
    public checkAutoGradeQns = '0';
    @ViewChild('submitAlert') submitAlert: TemplateRef<any>;
    @ViewChild('reviewAlert') reviewAlert: TemplateRef<any>;
    @ViewChild('durationWarning', {static: false}) durationWarning: TemplateRef<any>;
    @ViewChild('testTimerStatus', {static: false}) testTimerStatus: TemplateRef<any>;
    @ViewChild('answerGraph') answerGraph: TemplateRef<any>;
    @ViewChild('content') link: TemplateRef<any>;
    @ViewChild('workArea') workArea: TemplateRef<any>;
    @ViewChild('scrollContent', {static: false}) scrollContent: ElementRef;
    @ViewChild('rightArrow', {static: false}) rightArrow: ElementRef;
    @ViewChild('leftArrow', {static: false}) leftArrow: ElementRef;
    @ViewChild('feedback') feedback: TemplateRef<any>;
    @ViewChild('feedbackStatus') feedbackStatus: TemplateRef<any>;
    @ViewChild('goToFullScreen') goToFullScreen: TemplateRef<any>;
    // @ViewChild(SignaturePad , {static: true}) signaturePad: SignaturePad;
    @ViewChild('jumpWrapper') jumpWrapper!: ElementRef;
    @ViewChild('qnsWrapper') qnsWrapper!: ElementRef;
    @ViewChild('chart2', { static: true }) chartContainer!: ElementRef;

    convertedText: SafeHtml;
    reviseSelected = 'current';
    public feedbackServiceCalled = false;
    public selectedFeedBackIndex: any = '';
    public selectedVersion: any = 0;
    public selectedPreviousStudentAnswer: any;
    public previousFeedBack = [];
    public autoScoreRelease: boolean = false;
    public showpdf = true;
    public functionCalled: boolean;
    public delAnnotation: boolean;
    public answerPatch: boolean;
    public pdf: boolean;
    public guard = false;
    public showUploadFile = true;
    public mathDelayer = false;
    public workspacedata: any;
    public totalAns: any = [];
    public totalAnsSample = [];
    public answerEditor: any = [];
    public workSpaceEditor: any = [];
    public hideRuleContent = [];
    public hideRuleAnswer = [];
    public pdfPath: any;
    public isPdfAvailable: boolean = true;

    public dragQuestion: any = [];
    public blankAns: any = [];
    public answerPdf: any = [];
    public pageScroll = 0;
    public modalRef: NgbModalRef;
    private modalRef1: NgbModalRef;
    public allowSelect: boolean;
    public linkdata: any = [];
    page = 1;
    public showAnswerItem: any;
    public interval: any;
    public testInterval: any;
    public overAllInterval: any;
    public showAnswerI: any;
    public showAnswerJ: any;
    public answerSaving = false;
    private isAnswerRequestInFlight = false;
    private inFlightSaveStatus: string = null;
    private pendingFinalSubmit: { route: any; loader: any; questionMove: any } | null = null;
    private pendingNextModule: any = null;
    private pendingModuleLoadFrom: string = null;
    public expand = false;
    public expandData20: any;
    public maximumAttempt = 3;
    public correctAnswer = true;
    @ViewChild('showExpand') showExpand: TemplateRef<any>;
    private distance: number = 150;
    public showQuestion = 0;
    public timeTaken = 0;
    public timeTakenForTestInterval = 0;
    public timeIntervalRunningForTest = false;
    public serviceCalled = false;
    public overallTimeTaken = 0;
    public firstWarning = false;
    public submitAnswering = false;
    public percentage = '0';
    public tryAgainButtonEnabled = false;
    public buttonClicked = '';
    public previouslySelectedIndex = 0;
    public needSaveForThisQns = false;
    public selectedIndexForSameQns = 0;
    public graphEdited = false;
    public overallFullData: any;
    public maximumAllowedCount = 10;
    public minimumWordValidation = 200;
    public timeIntervalForCFS: any;
    public popUpMessage = '';
    showJumpQuestion = false;
    showDescription = false;
    public listPassageDetails = [];
    public showTimer = true;
    showCalculator = false;
    showReference = false;
    pdfSrc = 'https://whitlowmath.weebly.com/uploads/6/9/8/6/6986118/sat_set_1.pdf';
    calculator: any;
    public testElapsedTime: any;
    public overallElapsedTime: any;
    public testContentDetail: any = [];
    public testFullData: any;
    public testContentData: any;
    public contentName: any;
    public disableButton = false;
    public disableSkipButton = true;
    private skipModuleTimer: ReturnType<typeof setTimeout> | null = null;
    public disableDurationWarningButton = true;
    public feedbackList = [];
    public totalIndivialScore = 5;
    public totalScore = 0;
    public score = 0;
    public chartOptions: Partial<ChartOptions>;
    public totalFeedBackCount = 0;
    public feedbackListData = [];
    public timeIntervalForFeedback: any;

    @ViewChild('header') header!: ElementRef;
    @ViewChild('footer') footer!: ElementRef;
    @ViewChild('contentCard') contentCard!: ElementRef;

    contentMaxHeight = 'auto';
    totalContentMaxHeight = 'auto';
    totalFeedbackMaxHeight = 'auto';
    public feedbackExpanded = false;
    public isOpen = false;
    public sf = screenfull as Screenfull;
    public isGoToFullscreenOpen = false;
    secondsLeft = 60;
    totalSeconds = 60;
    radius = 28;
    circumference = 2 * Math.PI * this.radius;
    dashOffset = 0;
    public feedBackTimer: any;
    progress = 0;
    loadingCompleted = true;

    getAreaInfo = debounce(
        (event: any) => {
            this.areaInfo = event;
            const data = {
                platform: 'web',
                student_id: this.auth.getUserId(),
                annotation: this.areaInfo,
                content_id: this.getData.content_id,
                student_content_id: this.getData.student_content_id,
                class_id: this.getData.class_id,
            };
            this.creator.saveAnnotation(data).subscribe((successData) => {
                    this.saveAnnotationSuccess(successData);
                },
                (error) => {
                    this.saveAnnotationFailure(error);
                });
        }, 1000);

    protected readonly Object = Object;


    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent) {
        if (this.showJumpQuestion && !this.jumpWrapper.nativeElement.contains(event.target)) {
            this.showJumpQuestion = false;
        }

        if (this.showDescription && !this.qnsWrapper.nativeElement.contains(event.target)) {
            this.showDescription = false;
        }

    }

    @HostListener('window:resize')
    onResize() {
        console.log('resize _called');
        this.updateContentHeight();
    }

    ngOnInit(): void {
        this.allowSelect = true;
        this.newSubject.allowSchoolChange(this.allowSelect);
        this.creator.changeViewList(true);
        if (this.isTestContent() && this.getData.student_content_status != '1' && this.getData.student_content_status != '2') {
            this.getTestDetails();
        } else {
            this.questionList(this.getData);
        }

        this.auth.sidebarOpened$.subscribe(isOpen => {
            setTimeout(() => {
                this.isOpen = isOpen;
            }, 200);
        });
    }

    ngAfterContentInit(): void {
        setTimeout(() => {
            this.answerPatch = true;
        }, 3000);
        if (this.getData?.content_format == '1' && (this.getData.student_content_status == '1' || this.getData.student_content_status == '2')) {
            this.interval = setInterval(() => {
                this.saveAnswer('2', 'noExit', false);
            }, 300000);
        } else if (this.getData?.content_format == '3' && (this.getData.student_content_status == '1' || this.getData.student_content_status == '2')) {
            console.log(this.getData, 'getData_ngAfterViewInit');
            this.setServiceInterval('set');
        }
    }

    get scorePercentage(): number {
        return (this.score / this.totalScore) * 100;
    }

    convertMarkdownToHtml(markdown: string, splitCount = 0): SafeHtml {
        markdown = markdown.replace(/^'+|'+$/g, '');
        let html = markdown.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
        html = html.replace(/\\n/g, '<br>').replace(/\n/g, '<br>');
        if (splitCount != 0) {
            const words = html.split(' ');
            if (words.length > splitCount) {
                html = words.slice(0, splitCount).join(' ') + '......';
            }
        }
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    wordCount(item): number {
        const value = this.reviseSelected == '' && this.selectedFeedBackIndex != 0 && this.selectedFeedBackIndex != '' ?
            this.selectedPreviousStudentAnswer?.student_answer : item.given_answer[0].isSelected;
        return value ? value.trim().split(/\s+/).length : 0;
    }

    ngAfterViewInit() {
        this.updateContentHeight();
    }

    // tslint:disable-next-line:use-lifecycle-interface
    ngOnDestroy(): void {
        console.log('destroyCalled');
        if (this.timeIntervalForCFS) {
            clearInterval(this.timeIntervalForCFS);
        }

        if (this.timeIntervalForFeedback) {
            clearInterval(this.timeIntervalForFeedback);
        }
        this.auth.removeSessionData('sse_loader');
        this.auth.removeSessionData('classDetails');
        this.auth.removeSessionData('test_details');
        clearInterval(this.interval);
        if (this.overAllInterval) {
            clearInterval(this.overAllInterval);
        }
        if (this.interval) {
            this.timeTaken = 0;
            clearInterval(this.interval);
        }

        if (this.testInterval) {
            this.timeTakenForTestInterval = 0;
            clearInterval(this.testInterval);
        }
        this.clearSkipModuleTimer();
        this.clearPendingTestModule();
        this.pauseTimerIntervalOfTest();
        this.modalRef?.close();

        this.clearFeedBackTimer();

        if (this.sf.isFullscreen && this.questionData?.is_fullscreen == '1' && ['1', '2'].includes(this.getData.student_content_status)) {
            this.sf.toggle();
        } else if (this.sf.isFullscreen && !['1', '2'].includes(this.getData.student_content_status)) {
            this.sf.toggle();
        }
        if (this.isGoToFullscreenOpen) {
            this.modalRef.close(this.goToFullScreen);
        }
        this.creator.changeViewList(false);
    }

    showFeedback() {
        this.modalRef = this.modalService.open(this.feedback, {size: 'xl'});
    }

    updateContentHeight() {
        const availableHeight = !this.sf.isFullscreen ? window.innerHeight - 224 : window.innerHeight - 224;
        this.contentMaxHeight = `${availableHeight + 6}px`;
        this.totalFeedbackMaxHeight = `${availableHeight + 70}px`;
        this.totalContentMaxHeight = `${availableHeight + 78}px`;
        setTimeout(() => {
            // console.log(this.modalRef.)
            if (!this.sf.isFullscreen && this.questionData?.is_fullscreen == '1' && ['1', '2'].includes(this.getData.student_content_status)
                && !this.isGoToFullscreenOpen) {
                this.isGoToFullscreenOpen = true;
                this.modalRef = this.modalService.open(this.goToFullScreen, {backdrop: 'static'});

                this.modalRef.result.finally(() => this.isGoToFullscreenOpen = false);

            }
        }, 100);
    }

    numOfQuestionAnswered() {
        let questionAnswered = 0;
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.totalAns.forEach((items) => {
                const particularObjectValue = items.question_type_id != '24' ? items : items.subQuestions[0];

                if ( this.checkAutoGradeQns == '2' && (particularObjectValue.is_correct == 'true' || particularObjectValue.is_correct == 'false')) {
                    questionAnswered++;
                } else if (this.checkAutoGradeQns != '2' && particularObjectValue.is_correct == 'manual') {
                    questionAnswered++;
                }
            });
        } else {
            questionAnswered = this.totalAns.length;
        }
        return questionAnswered;
    }

    startTimer() {
        this.pauseTimer();
        this.interval = setInterval(() => {
            this.timeTaken++;
        }, 1000);
    }

    pauseTimer() {
        clearInterval(this.interval);
    }

    closeAndStartTimer() {
        // this.overAllStartTimer();
        this.firstWarning = false;
        this.disableDurationWarningButton = false;
        this.modalRef ? this.modalRef?.close() : '';
    }

    overAllStartTimer() {
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.overallPauseTimer();
            // this.overAllInterval = setInterval(() => {
            //     if (this.auth.loggedIn()) {
            //         this.overallElapsedTime = this.getElapsedOverAllTime();
            //         if (this.getData.content_duration != '0' && this.getData.content_duration != '') {
            //             this.overallTimeTaken--;
            //             this.getData.available_content_duration = this.overallTimeTaken;
            //             this.auth.setSessionData('classDetails', JSON.stringify(this.getData));
            //             if (this.overallTimeTaken == 300) {
            //                 this.overallPauseTimer();
            //                 this.firstWarning = true;
            //                 this.modalRef = this.modalService.open(this.durationWarning, {backdrop: 'static'});
            //             } else if (this.overallTimeTaken == 0) {
            //                 this.overallPauseTimer();
            //                 this.firstWarning = false;
            //                 this.modalRef = this.modalService.open(this.durationWarning, {backdrop: 'static'});
            //             }
            //         } else {
            //             this.overallTimeTaken++;
            //             this.getData.available_content_duration = this.overallTimeTaken;
            //             this.auth.setSessionData('classDetails', JSON.stringify(this.getData));
            //         }
            //     } else {
            //         clearInterval(this.overAllInterval);
            //     }
            // }, 1000);
            const durationSet = this.getData.content_duration && this.getData.content_duration !== '0';
            const initialAvailable = Number(this.getData.available_content_duration || 0);
            const initialTime = Date.now();

            this.overAllInterval = setInterval(() => {
                if (!this.auth.loggedIn()) {
                    clearInterval(this.overAllInterval);
                    return;
                }

                const now = Date.now();
                const elapsedSeconds = Math.floor((now - initialTime) / 1000);
                if (durationSet && (this.getData?.is_accessible == '0' || !this.getData?.is_accessible)) {
                    // Countdown mode
                    this.overallTimeTaken = initialAvailable - elapsedSeconds;
                    if (this.overallTimeTaken < 0) {
                        this.overallTimeTaken = 0;
                    }
                } else {
                    // Count up mode
                    this.overallTimeTaken = initialAvailable + elapsedSeconds;
                }
                // Update data and session
                this.getData.available_content_duration = this.overallTimeTaken;
                this.auth.setSessionData('classDetails', JSON.stringify(this.getData));

                // Update elapsed time view
                this.overallElapsedTime = this.getElapsedOverAllTime(this.overallTimeTaken);

                // Trigger warnings
                if (durationSet && (this.getData?.is_accessible == '0' || !this.getData?.is_accessible)) {
                    if (this.overallTimeTaken === 300) {
                        this.firstWarning = true;
                        this.disableDurationWarningButton = false;
                        this.modalRef ? this.modalRef?.close() : '';
                        setTimeout(() => {
                            this.modalRef = this.modalService.open(this.durationWarning, { backdrop: 'static' });
                        }, 0);
                    }
                    if (this.overallTimeTaken <= 0) {
                        this.overallPauseTimer();
                        this.disableDurationWarningButton = false;
                        this.firstWarning = false;
                        this.modalRef ? this.modalRef?.close() : '';
                        setTimeout(() => {
                            this.modalRef = this.modalService.open(this.durationWarning, { backdrop: 'static' });
                        }, 0);
                    }
                }

            }, 1000);
        }
    }

    overallPauseTimer() {
        clearInterval(this.overAllInterval);
    }

    expandFullScreen(item, i, j) {
        console.log(item, 'item');
        console.log(i, 'j');
        console.log(i, 'j');
        if (item.question_type_id == 20) {
            this.modalRef = this.modalService.open(this.showExpand, {size: 'xl', backdrop: 'static'});
            this.showAnswerItem = item;
            this.showAnswerI = i;
            this.showAnswerJ = j;
        } else if (item.question_type_id == 30) {
            item.given_answer = item.given_answer1;
            this.modalRef = this.modalService.open(this.showExpand, {size: 'xl', backdrop: 'static'});
            this.showAnswerItem = item;
            this.showAnswerI = i;
            this.showAnswerJ = j;
            this.hideRuleAnswer[i].section[j] = false;
        }
    }

    patchMinimize(i, j, item) {
        this.close();
        if (item.question_type_id == '30') {
            this.totalAns[i].section[j].given_answer = this.totalAns[i].section[j].given_answer1;
            this.hideRuleAnswer[i].section[j] = true;
        } else if (item.question_type_id == '20') {
            this.totalAns[i].section[j].given_answer = this.expandData20;
        }
    }

    clickEvent() {
        if (!this.mathDelayer) {
            this.mathDelayer = true;
            setTimeout(() => {
                document.getElementById('myDiv').click();
            }, 1000);
        }
        setTimeout(() => {
            this.mathDelayer = false;
        }, 3000);
    }

    showPdf() {
        this.pdf = !this.pdf;
        if (this.pdf) {
            this.button = 'Hide PDF';
        } else {
            this.button = 'Show PDF';
        }
    }

    // getAreaInfo(event) {
    //     this.areaInfo = event;
    //     const data = {
    //         platform: 'web',
    //         student_id: this.auth.getUserId(),
    //         annotation: this.areaInfo,
    //         content_id: this.getData.content_id,
    //         student_content_id: this.getData.student_content_id,
    //         class_id: this.getData.class_id,
    //     }
    //     const value = debounce({
    //
    //         this.creator.saveAnnotation(data).subscribe((successData) => {
    //                 this.saveAnnotationSuccess(successData);
    //             },
    //             (error) => {
    //                 this.saveAnnotationFailure(error);
    //             });
    //     }
    //         this.saveAnnotation(), 1000
    //     )
    //     // this.saveAnnotation();
    // }

    getDeleteAction(event) {
        this.delAnnotation = event;
    }

    getCurrentPageNo(event) {
        if (typeof event == 'number') {
            this.scrolledPageNumber = event;
        }
    }

    expandPdfSize(event) {
        this.expandPdf = event;
    }

    parseVal(val) {
        if (val != '' && val != null) {
            return parse(val);
        } else {
            return false;
        }
    }

    patchFreeTextVal() {
        this.totalAns.forEach((item, i) => {
            item.section.forEach((value, j) => {
                if (value.question_type_id == '30' && value.given_answer1) {
                    this.hideRuleAnswer[i].section[j] = false;
                    value.given_answer = value.given_answer1;
                }
            });
        });
        this.clickEvent();
    }

    patchWorkspaceVal() {
        this.totalAns.forEach((item, i) => {
            item.section.forEach((value, j) => {
                if (value.student_roughdata1) {
                    this.hideRuleContent[i].section[j] = false;
                    value.student_roughdata = value.student_roughdata1;
                }
            });
        });
    }

    setAnswer(id, index) {
        this.patchFreeTextVal();
        this.hideRuleAnswer[id].section[index] = !this.hideRuleAnswer[id].section[index];
    }

    submitAnswer(value, i, j) {
        console.log(value, 'value');
        console.log(i, 'j');
        console.log(i, 'j');
        this.totalAns[i].section[j].given_answer = value;
        this.hideRuleAnswer[i].section[j] = false;
        this.clickEvent();
    }

    toggle(i, j) {
        // toggle based on index
        this.patchWorkspaceVal();
        this.hideRuleContent[i].section[j] = true;
    }

    toggle1(i, j) {
        // toggle based on index
        this.hideRuleContent[i].section[j] = false;
    }

    getNumericAnswerValue(event, i, j) {
        if (this.answerEditor[i]) {
        } else {
            this.answerEditor[i] = {section: []};
        }
        this.answerEditor[i].section[j] = event;
        this.totalAns[i].section[j].given_answer1 = event.content;
        this.totalAns[i].section[j].answer_attended = '1';
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    getNumericAnswerValue1(event, i, j) {
        console.log(event.content, 'iopwe');
        // this.hideRuleAnswer[j] = false;
        console.log(this.answerEditor[i].section[j], 'small editor');
        // this.answerEditor[i].section[j].content = event.content;
        this.totalAns[i].section[j].given_answer1 = event.content;
        // this.totalAns[i].section[j].given_answer = event.content;
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    getNumericWorkSpaceValue(event, i, j) {
        if (this.workSpaceEditor[i]) {
        } else {
            this.workSpaceEditor[i] = {section: []};
        }
        // this.workSpaceEditor[i].section[j].content = event;
        this.totalAns[i].section[j].student_roughdata1 = event.content;
        this.totalAns[i].section[j].answer_attended = '1';
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    getWorkSpaceValue(event, i) {
        if (this.page != 1) {
            i = ((this.page - 1) * 10) + i;
        }
        if (event.content != '') {
            this.totalAns[i].student_roughdata = event.content;
        }
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    getPassageWorkSpaceValue(event, i, j, item) {
        console.log(item);
        console.log(item.student_roughdata);
        if (event.content != '') {
            item.student_roughdata = event.content;
        }
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    getGraphEditorValue(event) {
        this.graphEditorAns = event.content;
    }

    getChooseAns(event, i, j) {
        this.totalAns[i].section[j].given_answer = this.totalAns[i].section[j].array[event];
        this.totalAns[i].section[j].answer_attended = '1';
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    getInputAns(event, i, j) {
        this.totalAns[i].section[j].given_answer = event.target.value;
        this.totalAns[i].section[j].answer_attended = '1';
        this.expandData20 = event.target.value;
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    getBlanksValue(event, index, i, j) {
        for (let k = 0; k < this.totalAns[i].section[j].answer.length; k++) {
            if (k == index) {
                this.blankAns[i].section[j].input[index] = event.target.value;
            } else if (this.blankAns[i].section[j].input[k] == undefined) {
                this.blankAns[i].section[j].input[k] = '';
            }
        }
        this.totalAns[i].section[j].given_answer = this.blankAns[i].section[j].input;
        this.totalAns[i].section[j].answer_attended = '1';
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    toggleEliminator(event: Event, item: any, index: number) {
        item.given_answer[index].eliminated = !item.given_answer[index].eliminated;
        event.stopPropagation();
    }

    cfsGetMultiChoice(index, id, item) {
        if (this.page != 1) {
            index = ((this.page - 1) * 10) + index;
        }
        if (item.question_type_id == '2') {
            if (this.totalAns[index].given_answer[id].isSelected == '') {
                this.totalAns[index].given_answer[id].isSelected = id.toString();
            } else {
                this.totalAns[index].given_answer[id].isSelected = '';
            }
        } else if (item.question_type_id == '1') {
            for (let i = 0; i < this.totalAns[index].given_answer.length; i++) {
                this.totalAns[index].given_answer[i].isSelected = '';
                if (i === id) {
                    if (this.totalAns[index].given_answer[id].isSelected == '') {
                        this.totalAns[index].given_answer[id].isSelected = id.toString();
                    } else {
                        this.totalAns[index].given_answer[id].isSelected = '';
                    }
                }
            }
        }
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    onPageChange(data) {
        this.pdfPath = this.common.convertBase64(this.questionData.file_path);
        if (this.pdfPath.length == 0) {
            this.workspacedata = this.totalAns;
            this.workspacedata.forEach((items) => {
                if (items.question_type_id != '24') {
                    items.PatchData = items.student_roughdata != '';
                } else {
                    items.subQuestions.forEach((sub) => {
                        sub.patchData = sub.student_roughdata != '';
                    });
                }
            });
        } else {
            this.workspacedata = this.totalAns;
            this.workspacedata.forEach((val) => {
                val.section.forEach((items) => {
                    if (items.question_type_id == '40') {
                        items.PatchData = items.student_roughdata != '';
                    }
                });
            });
        }

        this.page = data;
        window.scrollTo(0, 0);
        for (let i = 0; i < this.totalAns.length; i++) {
            if (this.totalAns[i].question_type_id == '20') {
                this.totalAns[i].given_answer[0].isSelected = this.totalAns[i].given_answer[0].isSelected1;
            } else if (this.totalAns[i].question_type_id == '10') {
                for (let j = 0; j < this.totalAns[i].given_answer.length; j++) {
                    if (this.totalAns[i].given_answer[j].isSelected1) {
                        this.totalAns[i].given_answer[j].isSelected = this.totalAns[i].given_answer[j].isSelected1;
                    } else {
                        this.totalAns[i].given_answer[j].isSelected = '';
                    }
                }
            } else if (this.totalAns[i].question_type_id == '24') {
                for (let j = 0; j < this.totalAns[i].subQuestions.length; j++) {
                    if (this.totalAns[i].subQuestions[j].question_type_id == '10') {
                        for (let k = 0; k < this.totalAns[i].subQuestions[j].given_answer.length; k++) {
                            if (this.totalAns[i].subQuestions[j].given_answer[k].isSelected1) {
                                this.totalAns[i].subQuestions[j].given_answer[k].isSelected = this.totalAns[i].subQuestions[j].given_answer[k].isSelected1;
                            } else {
                                this.totalAns[i].subQuestions[j].given_answer[k].isSelected = '';
                            }
                        }
                    }
                }
            }
        }
        this.clickEvent();
        // this.save
        // this.saveAnswer('2', 'noExit');
    }

    cfsGetChooseTable(item, index, row, column) {
        if (item.question_type_id == '5') {
            for (let i = 0; i < item.given_answer.length; i++) {
                if (i === row) {
                    item.given_answer[i].isSelected = column.toString();
                }
            }
        } else if (item.question_type_id == '7') {
            for (let i = 0; i < item.given_answer.length; i++) {
                let val = '';
                if (item.given_answer[i].isSelected !== '') {
                    const split = item.given_answer[i].isSelected.split(',');
                    let repeat = false;
                    for (let y = 0; y < split.length; y++) {
                        if (split[y] == column) {
                            split.splice(y, 1);
                            repeat = true;
                        }
                    }
                    if (repeat == true) {
                        val = split.join(',');
                    } else {
                        val = item.given_answer[i].isSelected + ',' + column;
                    }
                } else {
                    val = column.toString();
                }
                if (i === row) {
                    item.given_answer[i].isSelected = val;
                }
            }
        }
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    dropdownId(index, id) {
        if (this.page != 1) {
            index = ((this.page - 1) * 10) + index;
        }
        return index + 'dropdown' + id;
    }

    cfsGetDropdown(event, index, id, ans, val) {
        if (this.page != 1) {
            index = ((this.page - 1) * 10) + index;
        }
        this.totalAns[index].given_answer[id].isSelected = ans.toString();
        document.getElementById(index + 'dropdown' + id).innerHTML = val;
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
        this.clickEvent();
    }

    cfsPatchDropdown() {
        setTimeout(() => {
            for (let i = 0; i < this.totalAns[this.showQuestion].answer.length; i++) {
                for (let j = 0; j < this.totalAns[this.showQuestion].answer[i].options.length; j++) {
                    if (this.totalAns[this.showQuestion].answer[i].options[j].selected == 'true') {
                        document.getElementById('dropdown' + i).innerHTML = this.totalAns[this.showQuestion].answer[i].options[j].listOption;
                    }
                }
            }
        }, 500);
    }

    cfsGetInput(event, index, id, item) {
        if (item.editor_type == 1) {
            item.given_answer[id].isSelected1 = event.target.value;
        } else {
            item.given_answer[id].isSelected1 = event.content;
        }
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    cfsGetPara(event, index) {
        console.log(event, 'event');
        if (this.page != 1) {
            index = ((this.page - 1) * 10) + index;
        }
        this.totalAns[index].given_answer[0].isSelected1 = event.content;
        console.log(this.totalAns[index].given_answer, 'gn')
        if ((this.getData.student_content_status == '1' || this.getData.student_content_status == '2') && event.content != '') {
            this.guard = true;
        }
    }

    cfsGetHighlight(event, index) {
        if (this.page != 1) {
            index = ((this.page - 1) * 10) + index;
        }
        this.totalAns[index].given_answer[0].isSelected = event.content;
        if ((this.getData.student_content_status == '1' || this.getData.student_content_status == '2') && event.content != '') {
            this.guard = true;
        }
    }

    cfsgetGraphValue(event, index) {
        this.totalAns[index].given_answer[0].isSelected = event;
        this.totalAns[index].answer_valueEmitted = true;
        this.graphEdited = true;
        console.log(this.totalAns[index].given_answer[0].isSelected, 'isSelected');
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    cfsGetGraghEditor(event, index) {
        if (this.page != 1) {
            index = ((this.page - 1) * 10) + index;
        }
        this.totalAns[index].editor_key = event.content;
        if ((this.getData.student_content_status == '1' || this.getData.student_content_status == '2') && event.content != '') {
            this.guard = true;
        }
    }

    cfsPassageMultiChoice(index, id, it, item) {
        // item.given_answer[it].isSelected = it;
        if (item.question_type_id == '2') {
            if (item.given_answer[it].isSelected == '') {
                item.given_answer[it].isSelected = it.toString();
            } else {
                item.given_answer[it].isSelected = '';
            }
        } else if (item.question_type_id == '1') {

            for (let i = 0; i < item.given_answer.length; i++) {

                if (i == it) {
                    if (item.given_answer[it].isSelected == '') {
                        item.given_answer[it].isSelected = it.toString();
                    } else {
                        item.given_answer[it].isSelected = '';
                    }
                } else {
                    item.given_answer[i].isSelected = '';
                }
            }
        }
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            this.guard = true;
        }
    }

    cfsGetPassageEssay(event, index, list) {
        if (list.given_answer.length != 0) {
            list.given_answer[0].isSelected = event.content;
            list.given_answer[0].isSelected1 = event.content;
        } else {
            console.log(list.given_answer);
            list.given_answer.push({isSelected1: event.content});
        }
    }

    splitMultiChoose(val, index) {
        const value = val.split(',');
        for (let i = 0; i < value.length; i++) {
            if (parseInt(value[i]) === parseInt(index)) {
                return true;
            }
        }
    }

    patchCorrectMultiChoiceAnswer(data, index, secondIndex) {
        let patchValue = false;
        data.forEach((items) => {
            if (items.correctActive == secondIndex) {
                if (items.correctAnswer == index) {
                    patchValue = true;
                }
            }
        });
        return patchValue;
    }

    droppedCorrect(event: CdkDragDrop<string[]>, index) {
        const control = this.totalAns[index].given_answer as any;
        this.totalAns[index].answer_shuffled = true;
        moveItemInArray(control, event.previousIndex, event.currentIndex);
    }

    openGraph(event, i, j, item) {
        this.workAnnotate = [...item.workarea];
        this.graphAnswerVal = '';
        this.graphFeedback = item.student_feedback;
        this.graphId = i;
        this.graphIndex = j;
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            content_id: this.getData.content_id,
            content_format: this.getData.content_format,
            class_id: this.getData.class_id,
            student_id: this.auth.getUserId(),
            question_id: this.totalAns[i].section[j].answer_id,
            student_content_id: this.getData?.student_content_id,
            type: '2'
        };
        this.creator.graphAnswer(data).subscribe((successData) => {
                this.getGraphSuccess(successData);
            },
            (error) => {
                this.getGraphFailure(error);
            });
        this.modalRef1 = this.modalService.open(this.answerGraph, {size: 'lg'});
    }

    getGraphSuccess(successData) {
        if (successData.IsSuccess) {
            this.graphAnswerVal = successData.ResponseObject[0].student_answer[0]?.correctAnswer;
            this.graphEditorAns = successData.ResponseObject[0].editor_answer;
            this.graphEditorAnsDup = successData.ResponseObject[0].editor_answer != '';
            this.getGraph = this.parseVal(this.graphAnswerVal);
        }
    }

    getGraphFailure(error) {
        console.log(error);
    }

    getDropdownAns(event, i, j) {
        this.totalAns[i].section[j].given_answer = this.totalAns[i].section[j].mob_options[event];
        this.totalAns[i].section[j].answer_attended = '1';
    }

    getTrueAns(event, i, j) {
        this.totalAns[i].section[j].given_answer = event;
        this.totalAns[i].section[j].answer_attended = '1';
    }

    storeGraph(event) {
        this.getGraph = event;
    }

    deletePdf(id) {
        this.answerPdf.splice(id, 1);
    }

    uploadAnswerPdf(event) {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),

        };
    }

    saveGraph(event, val, id) {
        this.graphBoardValue = event;
        let list;
        const objects = {};
        for (const el in this.graphBoardValue.objects) {
            const inherit = [];
            this.graphBoardValue.objects[el].inherits.forEach((item) => {
                inherit.push({name: item.name});
            });
            objects[el] = {
                elType: this.graphBoardValue.objects[el].elType,
                coords: this.graphBoardValue.objects[el].coords,
                name: this.graphBoardValue.objects[el].name,
                inherits: inherit,
                parents: this.graphBoardValue.objects[el].parents,
                splinePoints: this.graphBoardValue.objects[el].splinePoints,
                quadraticform: this.graphBoardValue.objects[el].quadraticform,
            };
        }
        const graph = {
            attr: this.graphBoardValue.attr,
            objects
        };
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            content_id: this.getData.content_id,
            content_format: this.getData.content_format,
            class_id: this.getData.class_id,
            student_id: this.auth.getUserId(),
            question_id: id.question_id,
            answer: [{correctAnswer: stringify(graph), correctActive: ''}],
            editor_answer: val,
            type: '1',
            student_content_id: this.getData?.student_content_id
        };
        this.creator.graphAnswer(data).subscribe((successData) => {
                this.saveGraphSuccess(successData, '2', id, data);
            },
            (error) => {
                this.saveGraphFailure(error);
            });
    }

    getGraphAnswerValue(event, i, j) {
        this.graphBoardValue = event;
        let list;
        let graph: any;
        let graphAnswerData: any;
        if (this.graphBoardValue != undefined && this.graphBoardValue != '') {
            const objects = {};
            for (const el in this.graphBoardValue.objects) {
                const inherit = [];
                this.graphBoardValue.objects[el].inherits.forEach((item) => {
                    inherit.push({name: item.name});
                });
                objects[el] = {
                    elType: this.graphBoardValue.objects[el].elType,
                    coords: this.graphBoardValue.objects[el].coords,
                    name: this.graphBoardValue.objects[el].name,
                    inherits: inherit,
                    parents: this.graphBoardValue.objects[el].parents,
                    splinePoints: this.graphBoardValue.objects[el].splinePoints,
                    quadraticform: this.graphBoardValue.objects[el].quadraticform,
                };
            }
            graph = {
                attr: this.graphBoardValue.attr,
                objects
            };
            graphAnswerData = [{correctAnswer: stringify(graph), correctActive: ''}];
        } else {
            graphAnswerData = [{correctAnswer: '', correctActive: ''}];
        }

        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            content_id: this.getData.content_id,
            content_format: this.getData.content_format,
            class_id: this.getData.class_id,
            student_id: this.auth.getUserId(),
            question_id: this.totalAns[i].section[j].answer_id,
            answer: graphAnswerData,
            student_answer: graphAnswerData,
            editor_answer: this.graphEditorAns,
            student_content_id: this.getData.student_content_id,
            type: '1'
        };
        this.creator.graphAnswer(data).subscribe((successData) => {
                this.saveGraphSuccess(successData, '1');
            },
            (error) => {
                this.saveGraphFailure(error);
            });
    }

    saveGraphSuccess(successData, id, data?, JSONObject?) {
        if (id == '1') {
            this.closeGraph(this.graphId, this.graphIndex);
            this.graphEditorAns = '';
        }
        if (data) {
            data.given_answer = JSONObject.answer;
            this.graphEdited = false;
        }
    }

    saveGraphFailure(error) {
        console.log(error);
    }

    getQueries(event, i, j, type) {
        if (type == 'pdf') {
            this.queriesIndex = j + 'id' + i;
        } else if (type == 'scratch') {
            this.queriesIndex = 'id' + i;
        } else {
            this.queriesIndex = j + 'id' + i;
        }
        this.queries = event.target.value;
    }

    submitQueries(i, j, type) {
        let studentAnswer: any;
        if (type == 'pdf') {
            studentAnswer = this.totalAns[i].section[j].answer_id;
        } else if (type == 'scratch') {
            if (this.page != 1) {
                i = ((this.page - 1) * 10) + i;
            }
            studentAnswer = this.totalAns[i].question_type_id != '24' ? this.totalAns[i].question_id : this.totalAns[i].subQuestions[0].question_id;
        } else {
            if (this.page != 1) {
                i = ((this.page - 1) * 10) + i;
            }
            studentAnswer = this.totalAns[i].subQuestions[j].question_id;
        }
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            content_id: this.getData.content_id,
            content_format: this.getData.content_format,
            class_id: this.getData.class_id,
            student_id: this.auth.getUserId(),
            answer_id: studentAnswer,
            suggestion_query: this.queries
        };
        this.student.submitQuery(data).subscribe((successData) => {
            this.submitQuerySuccess(successData, i, j);
        }, (error) => {
            this.submitQueryFailure(error);
        });
    }

    submitQuerySuccess(successData, id, index) {
        if (successData.IsSuccess) {
            console.log(this.totalAns[id], 'dsadas');
            if (this.showpdf) {
                this.totalAns[id].section[index].student_feedback = this.queries;
            } else {
                this.totalAns[id].student_feedback = this.queries;
            }
            this.queriesIndex = '';
            this.queries = '';
            this.toastr.success(successData.ResponseObject);
        }
    }

    submitQueryFailure(error) {
        console.log(error);
    }

    getAnnotation(pdfPath) {
        const decodedStringBtoA = this.auth.getAccessToken() + '|' + this.auth.getUserId() + '|' + this.getData.content_id + '|' + this.getData.class_id;
        const encodedStringBtoA = btoa(decodedStringBtoA);
        const encodedStringBtoA1 = btoa(encodedStringBtoA);
        const data = {
            platform: 'web',
            student_content_id: this.getData.student_content_id,
            authorization_key: encodedStringBtoA1
        };
        this.creator.getStudDetail(data).subscribe((successData) => {
                this.getAnnotationSuccess(successData, pdfPath);
            },
            (error) => {
                this.getAnnotationFailure(error);
            });
    }

    getAnnotationSuccess(successData, pdfPath) {
        if (successData.IsSuccess) {
            console.log(this.common.convertBase64(successData.ResponseObject.pdfpath), 'successData.ResponseObject.pdfpath');

            successData.ResponseObject.teacher_annotation.forEach((item) => {
                item.isTeacherCorrection = false;
            });
            this.areaInfo = [...this.areaInfo, ...successData.ResponseObject.student_annotation, ...successData.ResponseObject.teacher_annotation];
            if(pdfPath[0]?.original_image_url != undefined) {
                this.common.downloadfilewithbytes(this.webhost + '/' + pdfPath[0]?.original_image_url)
                    .subscribe((filebytes: ArrayBuffer) => {
                        this.pdfTemplate = filebytes;
                        this.functionCalled = true;
                        this.isPdfAvailable = true;
                        this.overallFullData = successData;
                        console.log(this.overallFullData, 'overallFullData');
                    });
                setTimeout(() => {
                    this.saveAnnotation();
                }, 2000);
            } else {
                this.isPdfAvailable = false;
                this.functionCalled = true;
            }
            // this.functionCalled = true;
            // while(document.getElementById('scrollinnnersection').offsetHeight < 500){

            // console.log(document.getElementById('scrollinnnersection').offsetHeight ,'2')
            //     this.pageScroll += 1;
            //     this.totalAns.push(this.totalAnsSample[this.pageScroll]);
            // this.totalAns.push(this.totalAnsSample[0]);
            // this.pushAnsArr();

        }
    }

    getAnnotationFailure(error) {
        console.log(error);
    }

    pushAnsArr() {
        console.log('1');
        console.log(document.getElementById('scrollinnnersection').offsetHeight, 'document.getElementById(\'scrollinnnersection\').offsetHeight');

        if (document.getElementById('scrollinnnersection').offsetHeight < 400) {
            this.pageScroll += 1;
            this.totalAns.push(this.totalAnsSample[this.pageScroll]);
            setTimeout(() => {
                this.pushAnsArr();
            }, 900);

        } else {
            return false;
        }
    }

    tryAgainButton() {
        document.getElementById('yourTarget').scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'start'
        });
        this.tryAgainButtonEnabled = true;
        this.startTimer();
    }

    changeQuestionListFromTest(event) {
        const contentId = event?.content_id ?? event;
        if (!contentId) {
            return;
        }
        const testDetails = JSON.parse(this.auth.getSessionData('test_details'));
        const selectedModule = testDetails[0]?.contents.find((value) => value.content_id == contentId);
        if (!selectedModule) {
            return;
        }
        this.scheduleTestModuleLoad(selectedModule, 'module_change');
    }

    private scheduleTestModuleLoad(module: any, calledFrom = 'skip'): void {
        if (this.skipModuleTimer || !module) {
            return;
        }
        // Active test skip: block if a next-module load is already pending.
        if (calledFrom == 'skip' && this.pendingNextModule) {
            return;
        }
        this.timeIntervalRunningForTest = true;
        this.disableSkipButton = true;
        this.pauseTimerIntervalOfTest();
        this.modalRef?.close();
        this.popUpMessage = 'Please wait while we load next module ...';
        this.modalRef = this.modalService.open(this.feedbackStatus, {backdrop: 'static'});

        if (calledFrom == 'module_change') {
            // Review / ng-select: keep previous immediate getData switch.
            this.getData = module;
            this.testContentData = module.content_id;
            this.auth.setSessionData('classDetails', JSON.stringify(this.getData));
        } else {
            // Active test next-module: delay getData until questionList succeeds.
            this.pendingNextModule = module;
            this.pendingModuleLoadFrom = calledFrom;
            this.testContentData = module.content_id;
        }

        if (module.content_started_at == null && (module.student_content_status == '1' || module.student_content_status == '2')) {
            module.available_content_duration = parseInt(module.content_duration) * 60;
            this.cdr.detectChanges();
            this.auth.updateContentStatus(module, '');
        }

        this.skipModuleTimer = setTimeout(() => {
            this.skipModuleTimer = null;
            this.showQuestion = 0;
            this.questionList(module, 'skip');
            if (calledFrom == 'skip') {
                this.setServiceInterval('set');
            }
        }, 1000);
    }

    private applyPendingTestModule(): void {
        if (!this.pendingNextModule) {
            return;
        }
        const module = this.pendingNextModule;
        this.getData = module;
        this.testContentData = module.content_id;
        this.auth.setSessionData('classDetails', JSON.stringify(this.getData));
        this.pendingNextModule = null;
        this.pendingModuleLoadFrom = null;
    }

    private clearPendingTestModule(): void {
        this.pendingNextModule = null;
        this.pendingModuleLoadFrom = null;
    }

    async questionList(details: any, calledFrom = '') {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            content_id: details.content_id,
            content_format: details.content_format,
            class_id: details.class_id || this.getData.class_id,
            student_content_id: details.student_content_id,
            class_content_id: details.class_content_id || this.getData.class_content_id,
            student_id: this.auth.getUserId(),
        };
        console.log(data, 'cotent');
        this.student.questionList(data).subscribe((successData) => {
            this.questionListSuccess(successData, calledFrom);
        }, (error) => {
            this.clearSkipModuleTimer();
            this.clearPendingTestModule();
            this.disableSkipButton = false;
            this.timeIntervalRunningForTest = false;
            this.modalRef?.close();
            console.error(error, 'error_questionList');
        });
    }

    isTestContent(data: any = this.getData): boolean {
        const value = data?.is_test;
        return value === '1' || value === 1 || value === true;
    }

    getBreakIntervalSeconds(module: any = this.getData): number {
        const raw = module?.interval_time;
        if (raw === null || raw === undefined || raw === '') {
            return 0;
        }
        const minutes = parseInt(String(raw), 10);
        if (!Number.isFinite(minutes) || minutes <= 0) {
            return 0;
        }
        return minutes * 60;
    }

    onTestBreakSkipClick(): void {
        if (this.disableSkipButton) {
            return;
        }
        this.disableSkipButton = true;
        this.timeTakenForTestInterval = 0;
        this.pauseTimerIntervalOfTest();
        this.skipToNextContent();
    }

    private clearSkipModuleTimer(): void {
        if (this.skipModuleTimer) {
            clearTimeout(this.skipModuleTimer);
            this.skipModuleTimer = null;
        }
    }

    private openTestBreakOrSkip(finishedModuleId?: string | number): void {
        const breakSeconds = this.getBreakIntervalSeconds();
        if (breakSeconds > 0) {
            this.clearSkipModuleTimer();
            this.disableSkipButton = false;
            this.timeTakenForTestInterval = breakSeconds;
            this.testElapsedTime = this.getElapsedTimeIntervalTest(breakSeconds);
            this.modalRef = this.modalService.open(this.testTimerStatus, {backdrop: 'static'});
            this.startTimerIntervalOfTest();
            return;
        }
        this.skipToNextContent(finishedModuleId);
    }

    questionListSuccess(successData, calledFrom) {
        if (successData.IsSuccess) {
            // Switch getData only after questions for the next module have loaded.
            this.applyPendingTestModule();

            this.questionData = successData.ResponseObject;
            // this.questionData1 = successData.ResponseObject;
            this.questionData1 = JSON.parse(JSON.stringify(successData.ResponseObject));
            console.log(this.questionData, 'questionData');
            this.setting();
            this.answerPdf = this.common.convertBase64(this.questionData.upload_answer);
            if (this.isTestContent()) {
                this.contentName = this.getData?.content_name + ' - ' + this.getData?.subject + ' - ' + this.getData?.module_name;
                const contentType = this.auth.getSessionData('ContentType');
                this.contentType = contentType == 'Assessments' ? 'Assessment' : 'Assignment';
                console.log(this.contentType, 'sdwedqwdqw')
            } else {
                this.contentName = this.questionData.name;
                this.contentType = this.questionData.content_type == '2' ? 'Assignment' : 'Assessment';
            }
            console.log(this.contentType, 'contentType_11');
            this.pdfPath = this.common.convertBase64(this.questionData.file_path);
            if (this.pdfPath.length != 0) {
                this.showpdf = true;
                this.pdf = true;
                this.totalAns = [];
                this.questionData.annotation.forEach((item) => {
                    item.isTeacherCorrection = false;
                });
                this.areaInfo = [...this.questionData.annotation];
                this.dragQuestion = [...this.questionData.questionAnnotation];
                this.totalFeedBack = this.questionData.overall_student_feedback;
                this.downloadTemplate = this.webhost + '/' + this.pdfPath[0]?.original_image_url;
                this.linkdata = this.pdfPath[0]?.links;
                this.downloadTemplateName = this.questionData.name + '.pdf';
                this.getAnnotation(this.pdfPath);
                if (this.questionData.answers.length != 0) {
                    for (let i = 0; i < this.questionData.answers.length; i++) {
                        this.questionData.answers[i].section.sort((a, b) => parseFloat(a.sub_questions[0].question_no) - parseFloat(b.sub_questions[0].question_no));
                    }
                    for (let i = 0; i < this.questionData.answers.length; i++) {
                        this.totalAns[i] = {heading: this.questionData.answers[i].heading, section: []};
                        this.workSpaceEditor[i] = {section: []};
                        this.hideRuleAnswer[i] = {section: []};
                        this.hideRuleContent[i] = {section: []};
                        this.answerEditor[i] = {section: []};
                        this.blankAns[i] = {section: []};
                        for (let x = 0; x < this.questionData.answers[i].section.length; x++) {
                            for (let j = 0; j < this.questionData.answers[i].section[x].sub_questions.length; j++) {
                                if (this.questionData.answers[i].section[x].sub_questions[j].page_no != 0) {
                                    this.showAutoScroll = true;
                                }
                                this.questionData.answers[i].section[x].sub_questions[j].answer_attended = '0';
                                this.totalAns[i].section.push(this.questionData.answers[i].section[x].sub_questions[j]);
                                this.hideRuleAnswer[i].section.push(false);
                                this.hideRuleContent[i].section.push(false);
                            }
                        }
                    }
                    this.workspacedata = this.totalAns;
                    this.totalAnsSample = this.totalAns;
                    this.totalAns = [];
                    if (this.totalAnsSample.length > 3) {
                        this.totalAnsSample.forEach((item, index) => {
                            if (index <= 3) {
                                this.pageScroll = index;
                                this.totalAns.push(this.totalAnsSample[index]);
                            }
                        });
                    } else {
                        this.totalAns = this.totalAnsSample;
                    }
                    // if (this.totalAnsSample.length > 1 && this.totalAnsSample[this.pageScroll].section.length < 3) {
                    //     this.pageScroll += 1;
                    //     this.totalAns.push(this.totalAnsSample[this.pageScroll]);
                    // }
                    this.workspacedata.forEach((val) => {
                        val.section.forEach((items) => {
                            if (items.question_type_id == '40') {
                                items.PatchData = items.student_roughdata != '';
                                console.log(items.PatchData, 'items.PatchData');
                            }
                        });
                    });
                    this.patchSomeIdVal();
                }
                console.log(this.showAutoScroll, 'this.showAutoScroll');
            } else {
                this.showpdf = false;
                this.linkdata = this.questionData.links;
                this.totalFeedBack = this.questionData.overall_student_feedback;
                this.totalAns = this.questionData.questions;
                this.timeTaken = this.totalAns.length != 0 ? this.totalAns[0]?.question_type_id != '24' ? this.totalAns[0]?.time_taken : this.totalAns[0]?.subQuestions[0]?.time_taken : 0;
                this.percentage = this.questionData?.percentage;
                this.checkAutoGradeQns = this.questionData.all_autograde == '1' ? this.questionData?.auto_review : '0';
                console.log(this.checkAutoGradeQns, 'autogade');
                this.workspacedata = this.questionData.questions;
                this.workspacedata.forEach((items) => {
                    if (items.question_type_id != '24') {
                        items.PatchData = items.student_roughdata != '';
                    } else {
                        items.subQuestions.forEach((sub) => {
                            sub.patchData = sub.student_roughdata != '';
                        });
                    }
                });
                for (let i = 0; i < this.totalAns.length; i++) {
                    this.totalAns[i].markedAsReview = this.totalAns[i].markedAsReview == 'true';
                    this.totalAns[i].workspaceClicked = !!(this.totalAns[i].workspaceClicked ?? this.isSingleQnsWithFeedbackType);
                    this.totalAns[i].feedBackClicked = !!(this.totalAns[i].feedBackClicked ?? this.isSingleQnsWithFeedbackType);
                    if (this.totalAns[i].question_type_id == '40' || this.totalAns[i].question_type_id == '41') {
                        console.log(this.totalAns[i].given_answer, 'givenAnswer');
                        this.totalAns[i].answer_valueEmitted = false;
                        this.totalAns[i].given_answer[0].isSelected = this.parseVal(this.totalAns[i].given_answer[0].correctAnswer);
                    } else if (this.totalAns[i].question_type_id == '16') {
                        this.totalAns[i].answer_shuffled = false;
                    } else if (this.totalAns[i].question_type_id == '24') {
                        for (let j = 0; j < this.totalAns[i].subQuestions.length; j++) {
                            const findIndex = this.listPassageDetails.length != 0 ?
                                this.listPassageDetails.findIndex(value => value.passage_id == this.totalAns[i].subQuestions[j].passage_id) : '';
                            this.totalAns[i].subQuestions[j].passage = findIndex != '' && findIndex != -1 ? this.listPassageDetails[findIndex].passage : this.totalAns[i].subQuestions[j].passage;
                            if (['1', '2'].includes(this.totalAns[i].subQuestions[j].question_type_id)) {
                                this.totalAns[i].subQuestions[j].given_answer.forEach(item => item.eliminated = item.eliminated ? item.eliminated : false);
                            }
                        }
                    } else if (['1', '2'].includes(this.totalAns[i].question_type_id)) {
                        this.totalAns[i].given_answer.forEach(item => item.eliminated = item.eliminated ? item.eliminated : false);
                    }
                }
                if (this.totalAns.length != 0) {
                    this.isSingleQnsWithFeedbackType && this.questionData?.auto_review != '0'
                        ? this.getFeedbackCount(this.totalAns[0], 'firstType') : '';
                    if (this.getData?.student_content_status == '1' || this.getData?.student_content_status == '2') {
                        let particularIndex = 0;
                        if (this.questionData.laq_id != 0) {
                            for (let i = 0; i < this.totalAns.length; i++) {
                                const particularObject = this.totalAns[i].question_type_id != '24' ? this.totalAns[i] : this.totalAns[i].subQuestions[0];
                                if (this.questionData.laq_id == particularObject.question_id) {
                                    particularIndex = i;
                                    if (this.serviceNeededOrNotFinalSubmit(this.totalAns[i])) {
                                        this.selectedQuestionList(this.totalAns[i], i, 'questionList');
                                        break;
                                    } else {
                                        const checkIndexValue = particularIndex;
                                        this.runLoop(checkIndexValue + 1, checkIndexValue);
                                    }
                                }
                            }
                        } else {
                            this.previouslySelectedIndex = 0;
                            this.selectedQuestionList(this.totalAns[0], 0, 'questionList');
                        }
                        const contentDuration = this.isTestContent() ? this.getData.content_duration : this.questionData.content_duration;
                        this.overallTimeTaken = this.getData.available_content_duration && contentDuration != '' && contentDuration != '0'
                            && (this.getData?.is_accessible == '0' || !this.getData?.is_accessible) ? this.getData.available_content_duration : contentDuration == '0' ?
                            parseInt(this.questionData.content_time_taken) : 0;
                        if (!(this.isSingleQnsWithFeedbackType && this.questionData?.auto_review != '0')) {
                            this.overAllStartTimer();
                        }
                    } else {
                        if (this.isTestContent()) {
                            this.overallTimeTaken = parseInt(this.testFullData?.content_time_taken);
                        } else {
                            this.overallTimeTaken = parseInt(this.questionData.content_time_taken);
                        }
                        this.overallElapsedTime = this.getElapsedOverAllTime(this.overallTimeTaken);
                        this.selectedQuestionList(this.totalAns[0], 0, 'questionList');
                    }
                    this.serviceCalled = true;
                    console.log(this.overallTimeTaken, 'overallTimeTaken');
                    this.timeIntervalRunningForTest = false;
                    if (calledFrom != '') {
                        this.modalRef ? this.modalRef?.close() : '';
                    }
                }

                if (calledFrom == '') {
                    this.updateContentHeight();
                    if (this.isSingleQnsWithFeedbackType) {
                        this.timeIntervalForFeedback = setInterval(() => {
                            this.getFeedBackList();
                        }, 10000);
                    }
                }
            }
        } else {
            this.clearPendingTestModule();
            this.toastr.info(successData.ResponseObject.message);
            if (successData.ResponseObject.content_type == '2') {
                this.route.navigate(['/studentlogin/assignment']);
            } else {
                this.route.navigate(['/studentlogin/assessment']);
            }
        }
        this.clickEvent();
    }

    runLoop(startIndex, endIndex, secondTime?) {
        for (let i = startIndex; i <= this.totalAns.length; i++) {
            const loopIndex = i;
            if (loopIndex == this.totalAns.length) {
                if (this.serviceNeededOrNotFinalSubmit(this.totalAns[loopIndex - 1])) {
                    this.selectedQuestionList(this.totalAns[loopIndex - 1], loopIndex, 'questionList');
                    break;
                } else {
                    this.runLoop(0, endIndex, 'second');
                }
            } else {
                if (secondTime == 'second' && endIndex == i) {
                    this.selectedQuestionList(this.totalAns[i], i, 'questionList');
                    break;
                } else {
                    if (this.serviceNeededOrNotFinalSubmit(this.totalAns[i])) {
                        this.selectedQuestionList(this.totalAns[i], i, 'questionList');
                        break;
                    }
                }
            }
        }
    }

    sectionFilter(event) {
        const scroll = document.getElementById('scrollinnnersection');
        scroll.scrollTo(0, 0);
        if (event.target.value == 'all') {
            this.pageScroll = 0;
            this.totalAns = [];
            if (this.totalAnsSample.length > 2) {
                for (let i = 0; i < 3; i++) {
                    this.pageScroll = i;
                    this.totalAns.push(this.totalAnsSample[this.pageScroll]);
                }
            } else {
                this.totalAns = [...this.totalAnsSample];
            }
        } else {
            this.totalAns = [this.totalAnsSample[parseInt(event.target.value)]];
        }
        console.log(this.totalAns, 'toatalans');
        console.log(this.totalAnsSample, 'totalAnsSample');
        this.patchSomeIdVal();
    }

    scrollToAnswerSection() {
        console.log(this.scrolledPageNumber, 'scrolledPage_1')
        if (!this.expandPdf && this.allowAutoScroll) {
            for (let i = 0; i < this.totalAns.length; i++) {
                for (let j = 0; j < this.totalAns[i].section.length; j++) {
                    const findPageNumber = this.totalAns[i].section.find(items => items.page_no == this.scrolledPageNumber);
                    console.log(findPageNumber, 'findpageNumber');
                    if (findPageNumber) {
                        const id = findPageNumber.page_no + '-' + findPageNumber.sub_question_no + '-' + j;
                        if (document.getElementById(id)) {
                            document.getElementById(id).scrollIntoView({
                                behavior: 'smooth',
                                block: 'end',
                                inline: 'start'
                            });
                            break;
                        }
                        console.log(this.scrolledPageNumber, 'scrolledPage_2')
                        console.log(this.totalAns[i].section[j].page_no, 'page_no');
                        console.log(id, 'id_page_no');
                    }
                }
            }
        }
    }

    finalPopUp() {
        const markedValue = this.totalAns.some(item => item.markedAsReview == true);
        console.log(markedValue, 'markedValue');
        if (markedValue) {
            this.modalRef = this.modalService.open(this.reviewAlert);
        } else {
            this.timeIntervalRunningForTest = true;
            this.buttonClicked = 'submit';
            this.submitPopup();
        }
        console.log(markedValue, 'markedValue');
    }

    submitPopup() {
        this.modalRef = this.modalService.open(this.submitAlert);
    }

    scrollDownPads() {
        // this.jsPDF.addPage();
        // this.jsPDF.insertPage(1);
        // this.samplePdf = this.jsPDF.output('datauristring');
        // this.signaturePad.scrollDownPad();

        // this.writtingPadHeight += 300;
        // // let elem = document.getElementById('signaturepad');
        // // this.signaturePad = elem;
        // console.log(this.signaturePad, 'signaturePad');
        // //
        // // elem.children[0].setAttribute('height' , this.writtingPadHeight);
        // this.signaturePadOptions = {
        //     minWidth: 1,
        //     maxWidth: 1,
        //     penColor: '#ce2222',
        //     canvasWidth: 460,
        //     canvasHeight: this.writtingPadHeight
        // };
        // this.resizeSignaturePad();
        // this.cdr.detectChanges();
    }

    drawComplete() {
        console.log('complete');
        // this.sigPadData = this.signaturePad.toDataURL();
    }

    onScrollDown() {
        if (this.totalAns.length < this.totalAnsSample.length && this.sectionFilterVal == 'all') {
            this.pageScroll += 1;
            console.log('enter scroll');
            this.totalAns.push(this.totalAnsSample[this.pageScroll]);
            this.patchSomeIdVal();
        }
    }

    scrollQues(event: MouseEvent) {
        const path = event.composedPath ? event.composedPath() : this.getPath(event.target as HTMLElement);

        if (this.allowAutoScroll && this.showAutoScroll && path) {
            for (let i = 0; i < path.length; i++) {
                const el = path[i] as HTMLElement;
                if (el && el.id) {
                    const split = el.id.split('-');
                    if (split.length === 3 && split[0] !== '0') {
                        this.scrolledPageNumber = parseInt(split[0]);
                        console.log(this.scrolledPageNumber, 'scrolledPageNumber');
                        break;
                    }
                }
            }
        }
    }

    getPath(element: HTMLElement): HTMLElement[] {
        const path: HTMLElement[] = [];
        while (element) {
            path.push(element);
            element = element.parentElement as HTMLElement;
        }
        return path;
    }

    patchSomeIdVal() {
        setTimeout(() => {
            for (let i = 0; i < this.totalAns.length; i++) {
                for (let j = 0; j < this.totalAns[i].section.length; j++) {
                    if (this.totalAns[i].section[j].student_roughdata != '') {
                        // this.workSpaceEditor[i].section[j]?.editor.setContent(this.totalAns[i].section[j].student_roughdata);
                        this.workSpaceEditor[i].section[j]?.editor.setContent(this.totalAns[i].section[j].student_roughdata);
                    }
                    if (this.totalAns[i].section[j].question_type_id == '30') {
                        if (this.totalAns[i].section[j].given_answer != '') {
                            this.answerEditor[i].section[j]?.editor.setContent(this.totalAns[i].section[j].given_answer);
                        }
                    } else if (this.totalAns[i].section[j].question_type_id == '54') {
                        this.blankAns[i].section[j] = {input: []};
                        for (let k = 0; k < this.totalAns[i].section[j].given_answer.length; k++) {
                            this.blankAns[i].section[j].input.push(this.totalAns[i].section[j].given_answer[k]);
                        }
                    }
                }
            }
            this.clickEvent();
        }, 2000);
    }

    validateAnswer() {
        this.totalAns.forEach((val, id) => {
            val.section.forEach((item, index) => {
                if (item.question_type_id == '54' && item.answer_attended != '3') {
                    let validate = false;
                    item.given_answer.forEach((arr) => {
                        if (arr != '') {
                            validate = true;
                        }
                    });
                    if (validate) {
                        item.answer_attended = '2';
                    }
                } else if (item.answer_attended != '3') {
                    if (item.given_answer != '') {
                        item.answer_attended = '2';
                    } else {
                        item.answer_attended = '0';
                    }
                }
            });
        });
    }

    getElapsedOverAllTime(totalSeconds: number): TimeSpan {
        let hours: any = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;

        let minutes: any = Math.floor(totalSeconds / 60);
        let seconds: any = totalSeconds % 60;

        hours = hours <= 9 ? '0' + hours : hours;
        minutes = minutes <= 9 ? '0' + minutes : minutes;
        seconds = seconds <= 9 ? '0' + seconds : seconds;

        return { hours, minutes, seconds };
    }

    // getElapsedOverAllTime(): TimeSpan {
    //     let totalSeconds = this.overallTimeTaken;
    //     let hours: any = 0;
    //     let minutes: any = 0;
    //     let seconds: any = 0;
    //     if (totalSeconds >= 3600) {
    //         hours = Math.floor(totalSeconds / 3600);
    //         totalSeconds -= 3600 * hours;
    //     }
    //
    //     if (totalSeconds >= 60) {
    //         minutes = Math.floor(totalSeconds / 60);
    //         totalSeconds -= 60 * minutes;
    //     }
    //
    //     seconds = totalSeconds;
    //     seconds = seconds <= 9 ? '0' + seconds : seconds;
    //     hours = hours <= 9 ? '0' + hours : hours;
    //     minutes = minutes <= 9 ? '0' + minutes : minutes;
    //     return {
    //         hours,
    //         minutes,
    //         seconds
    //     };
    // }

    getElapsedTime(): TimeSpan {
        let totalSeconds = this.timeTaken;
        let hours: any = 0;
        let minutes: any = 0;
        let seconds: any = 0;
        if (totalSeconds >= 3600) {
            hours = Math.floor(totalSeconds / 3600);
            totalSeconds -= 3600 * hours;
        }

        if (totalSeconds >= 60) {
            minutes = Math.floor(totalSeconds / 60);
            totalSeconds -= 60 * minutes;
        }

        seconds = totalSeconds;
        seconds = seconds <= 9 ? '0' + seconds : seconds;
        hours = hours <= 9 ? '0' + hours : hours;
        minutes = minutes <= 9 ? '0' + minutes : minutes;
        this.totalAns[this.showQuestion].question_type_id != '24' ? this.totalAns[this.showQuestion].time_taken = this.timeTaken :
            this.totalAns[this.showQuestion].subQuestions[0].time_taken = this.timeTaken;
        return {
            hours,
            minutes,
            seconds
        };
    }

    updateAnswer() {
        this.questionData.answers.forEach((value) => {
            value.section.forEach((sec) => {
                sec.sub_questions.forEach((item) => {
                    if (item.answer_attended == '1') {
                        item.answer_attended = '2';
                    }
                });
            });
        });
    }

    checkQuestionId(item) {
        return item.question_type_id != '24' ? item : item.subQuestions[0];
    }

    checkAnswerEntered(data) {
        let answerEntered = false;
        if (data.question_type_id == '1' || data.question_type_id == '2' || data.question_type_id == '5' || data.question_type_id == '7'
            || data.question_type_id == '9') {
            answerEntered = !data.given_answer.every((items) => {
                return items.isSelected == '';
            });
        } else if (data.question_type_id == '10') {
            data.given_answer.every((items) => {
                if (items.isSelected1) {
                    if (items.isSelected1.trim() != ''){
                        answerEntered = true;
                        return false;
                    }
                }
                return true;
            });
        } else if (data.question_type_id == '16') {
            answerEntered = data.answer_shuffled;
        } else if (['20', '55'].indexOf(data.question_type_id) > -1) {
            answerEntered = data.given_answer.some(items => items.isSelected != '') || data.given_answer.some(items => items.isSelected1 && items.isSelected1 != '');
        } else if (data.question_type_id == '40' || data.question_type_id == '41') {
            answerEntered = data.answer_valueEmitted;
        }
        return answerEntered;
    }

    getButtonClass(list: any, index: number): any {
        const currentQuestionData = this.checkQuestionId(list);
        const status = currentQuestionData?.is_correct;
        const isTest = this.isTestContent();
        const answerEntered = this.checkAnswerEntered(currentQuestionData);
        return {
            'bg-green': status === 'true' && !isTest,
            'bg-partially': ['partially-completed', 'manual'].includes(status) || (isTest && status !== '') || answerEntered,
            'bg-red': status === 'false' && !isTest,
            active: this.showQuestion === index
        };
    }

    getReviewIcon(status: string): string {
        return ['partially-completed', 'manual'].includes(status)
            ? 'assets/images/bookmark_checked_yellow.png'
            : 'assets/images/bookmark_checked.webp';
    }

    checkDisableConditionForQns(item) {
        const particularObjectValue = item.question_type_id != '24' ? item : item.subQuestions[0];
        return (this.getData.student_content_status != '1' && this.getData.student_content_status != '2')
            || particularObjectValue.is_correct == 'false' || particularObjectValue.is_correct == 'true' || (particularObjectValue.is_correct == 'partially-completed' && !this.tryAgainButtonEnabled);
    }

    checkForApiTypeQns() {
        if (this.isSingleQnsWithFeedbackType && this.questionData?.auto_review != '0') {
            if (this.totalAns[0].given_answer[0]?.isSelected.trim().split(/\s+/).length >= this.minimumWordValidation || this.minimumWordValidation == 0) {
                this.timeIntervalRunningForTest = true;
                this.buttonClicked = 'submit';
                this.modalRef = this.modalService.open(this.submitAlert);
            } else {
                this.toastr.error('Answer should be at least ' + this.minimumWordValidation + ' words.');
            }
        } else {
            this.timeIntervalRunningForTest = true;
            this.buttonClicked = 'submit';
            this.modalRef = this.modalService.open(this.submitAlert);
        }
    }

    checkFinalSave() {
        if (this.firstWarning) {
            this.modalRef ? this.modalRef?.close() : '';
        } else if (!this.firstWarning && this.overallTimeTaken <= 0) {
            this.disableDurationWarningButton = false;
            this.submitAnswering = true;
            this.saveAnswer('4', 'exit', true);
        }
    }

    passageList() {
        const testDetails = JSON.parse(this.auth.getSessionData('test_details'));

        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id')
        };

        if (testDetails) {
            data['content_id'] = testDetails[0]?.content_id ?? '';
        } else {
            data['content_id'] = this.getData?.content_id ?? '';
        }

        this.content.passageAllService(data, 'list').subscribe((successData) => {
                this.passageListSuccess(successData);
            },
            (error) => {
                console.error(error, 'error');
            });
    }

    passageListSuccess(successData) {
        this.listPassageDetails = successData.IsSuccess ? successData.ResponseObject : [];
        if (this.listPassageDetails.length != 0) {
            for (let i = 0; i < this.totalAns.length; i++) {
                if (this.totalAns[i].question_type_id == '24') {
                    for (let j = 0; j < this.totalAns[i].subQuestions.length; j++) {
                        const findIndex = this.listPassageDetails.length != 0 ?
                            this.listPassageDetails.findIndex(value => value.passage_id == this.totalAns[i].subQuestions[j].passage_id) : '';
                        this.totalAns[i].subQuestions[j].passage = findIndex != '' && findIndex != -1 ? this.listPassageDetails[findIndex].passage : this.totalAns[i].subQuestions[j].passage;
                    }
                }
            }
        }
    }

    setServiceInterval(calledType = 'set') {
        if (this.timeIntervalForCFS) {
            clearInterval(this.timeIntervalForCFS);
            this.timeIntervalForCFS = null;
        }
        this.timeIntervalRunningForTest = !(calledType == 'set');
        if (calledType == 'set') {
            if (this.isAnswerRequestInFlight && this.inFlightSaveStatus == '4') {
                this.timeIntervalRunningForTest = true;
                return;
            }
            this.timeIntervalForCFS = setInterval(() => {
                if (!this.timeIntervalRunningForTest && this.serviceCalled && !this.isAnswerRequestInFlight) {
                    console.log(this.getData, 'getDta_setService')
                    console.log('Service Called');
                    this.saveAnswer('2', 'noExit', false);
                }
            }, 60000);
        }
    }

    private releaseAnswerRequestLock(completedStatus?: string, wasSuccess = true): void {
        this.isAnswerRequestInFlight = false;
        this.inFlightSaveStatus = null;
        this.answerSaving = false;
        // After a successful final submit, drop any queued status-4 (already advanced).
        if (wasSuccess && completedStatus == '4') {
            this.pendingFinalSubmit = null;
            return;
        }
        if (this.pendingFinalSubmit) {
            const pending = this.pendingFinalSubmit;
            this.pendingFinalSubmit = null;
            this.saveAnswer('4', pending.route, pending.loader, pending.questionMove);
        }
    }

    async saveAnswer(id, route, loader, questionMove = '') {
        console.log(id, route, loader);

        // CFS / questions only — PDF (questionData.answers) must not use the in-flight lock.
        const isPdfContent = !!this.questionData?.answers;
        if (!isPdfContent) {
            if (this.isAnswerRequestInFlight) {
                if (String(id) === '4' && this.inFlightSaveStatus !== '4') {
                    this.pendingFinalSubmit = {route, loader, questionMove};
                }
                return;
            }
            this.isAnswerRequestInFlight = true;
            this.inFlightSaveStatus = String(id);
            this.answerSaving = true;
        }

        let allow = true;
        let finalArr = [];
        this.commondata.showLoader(loader);

        if (this.questionData.answers) {
            this.autoScoreRelease = true;
            this.updateAnswer();
            this.patchFreeTextVal();

            // if (this.totalAns.length < this.totalAnsSample.length && this.sectionFilterVal == 'all') {
            //     for (let i = 0; i < this.totalAns.length; i++) {
            //         this.totalAnsSample[i] = this.totalAns[i];
            //     }
            // } else if (this.totalAns.length < this.totalAnsSample.length && this.sectionFilterVal != 'all') {
            //     this.totalAnsSample[i] = this.totalAns[i];
            // }

            for (let i = 0; i < this.questionData.answers.length; i++) {
                for (let x = 0; x < this.questionData.answers[i].section.length; x++) {
                    for (let j = 0; j < this.questionData.answers[i].section[x].sub_questions.length; j++) {
                        if (this.questionData.answers[i].section[x].sub_questions[j].auto_grade == '0') {
                            this.autoScoreRelease = false;
                        }
                        const ans = this.questionData.answers[i].section[x].sub_questions[j];
                        for (let k = 0; k < this.totalAnsSample[i].section.length; k++) {
                            if (this.totalAnsSample[i].section[k].sub_question_no == ans.sub_question_no) {
                                if (this.totalAnsSample[i].section[k].question_type_id == 54) {
                                    if (this.totalAnsSample[i].section[k].given_answer.length != this.totalAnsSample[i].section[k].answer.length) {
                                        this.totalAnsSample[i].section[k].given_answer = [];
                                        for (let z = 0; z < this.totalAnsSample[i].section[k].answer.length; z++) {
                                            this.totalAnsSample[i].section[k].given_answer.push('');
                                        }
                                    }
                                }
                                if (this.totalAnsSample[i].section[k].question_type_id == 30) {
                                    if (this.totalAnsSample[i].section[k].given_answer1) {
                                        ans.given_answer = this.totalAnsSample[i].section[k]?.given_answer1;
                                    }
                                } else {
                                    ans.given_answer = this.totalAnsSample[i].section[k].given_answer;
                                }
                                ans.student_feedback = this.totalAnsSample[i].section[k].student_feedback;
                                ans.student_roughdata = this.totalAnsSample[i].section[k].student_roughdata1;
                            }
                        }
                    }
                }
            }
            finalArr = JSON.parse(JSON.stringify(this.questionData.answers));

            finalArr = finalArr.filter((value) => {
                value.section = value.section.filter((sec) => {
                    sec.sub_questions = sec.sub_questions.filter((item) => {
                        return item.answer_attended == '2';
                    });
                    return sec.sub_questions.length != '0';
                });
                return value.section.length != '0';
            });
            finalArr.forEach((value) => {
                value.section.forEach((sec) => {
                    sec.sub_questions.forEach((item) => {
                        item.answer_attended = '3';
                    });
                });
            });

            if ((finalArr.length == 0 && this.questionData.answers.length != 0) && !loader) {
                allow = false;
                // this.answerSaving = false;
                this.commondata.showLoader(false);
                // this.commondata.showLoader(false);
                return false;
            }
        } else {
            for (let i = 0; i < this.totalAns.length; i++) {
                if (this.totalAns[i].question_type_id == '40' || this.totalAns[i].question_type_id == '41') {
                    this.saveAnswerForFewType(i, 'save');
                } else if (questionMove == 'same' || id == '4') {
                    this.saveAnswerForFewType(i, 'save');
                }

                if (this.checkAutoGradeQns != '0' && id == '4') {
                    const questionNumber = this.showQuestion;
                    const particularObjectValue = this.totalAns[i].question_type_id != '24' ? this.totalAns[i] : this.totalAns[i].subQuestions[0];
                    if (particularObjectValue.is_correct == '' || particularObjectValue.is_correct == 'partially-completed' || particularObjectValue.is_correct == 'manual') {
                        this.totalAns[i].question_type_id != '55' ? this.pauseTimer() : '';
                        particularObjectValue.no_of_attempt = parseInt(particularObjectValue.no_of_attempt) + 1;
                        particularObjectValue.is_correct = this.totalAns[i].question_type_id != '55' ?
                            this.checkCorrectAnswerOrNot(particularObjectValue, 'allQuestion') : 'false';
                        particularObjectValue.time_taken = questionNumber == i ? this.timeTaken : particularObjectValue.time_taken;
                    }
                }
            }
        }

        let checkAllQuestionCorrectedOrNot = false;
        this.totalAns.every((items) => {
            const particularObjectValue = items.question_type_id != '24' ? items : items.subQuestions[0];
            if (particularObjectValue.is_correct == '' || particularObjectValue.is_correct == 'partially-completed') {
                checkAllQuestionCorrectedOrNot = true;
                return false;
            }
            return true;
        });
        this.totalAns.forEach((items) => {
            if (items.question_type_id != '55') {
                const particularObjectValue = items.question_type_id != '24' ? items : items.subQuestions[0];
                particularObjectValue.earned_points = particularObjectValue.is_correct == 'true' ? parseInt(particularObjectValue.points) : 0;
            } else if (items.question_type_id == '55') {
                items.time_taken = this.timeTaken;
            }
        });
        let data = {};
        console.log(this.getData?.is_test, 'is_test');
        if (this.questionData.answers) {
            data = {
                platform: 'web',
                role_id: this.auth.getRoleId(),
                user_id: this.auth.getUserId(),
                student_id: this.auth.getUserId(),
                content_id: this.questionData.content_id,
                content_format: this.questionData.content_format,
                student_content_id: this.getData.student_content_id,
                class_id: this.getData.class_id,
                overall_student_feedback: this.totalFeedBack,
                status: id,
                upload_answer: this.answerPdf,
                answers: finalArr
            };
        } else {
            const content_time_taken = this.getData.content_duration != '0' && (this.getData?.is_accessible == '0' || !this.getData?.is_accessible)
                ? parseInt(this.getData.content_duration) * 60 - this.overallTimeTaken : this.overallTimeTaken;
            const keyName = ['editor_context', 'question', 'level', 'passage_id', 'passage_title', 'passage', 'resource',
                'question_topic', 'sub_topic',  'question_standard_name', 'subject_name', 'answer_instructions',
                'rough_image_url', 'rough_image_thumb_url', 'student_answer_image', 'jiixdata', 'roughdata',
                'multiple_response', 'exact_match', 'hint', 'explanation', 'word_limit',
                'scoring_instruction', 'source', 'target', 'has_sub_question', 'editor_answer', 'editor_type'];

            const removeKeys = (obj) => {
                keyName.forEach((key) => {
                    if (key in obj) {
                        delete obj[key];
                    }
                });
                return obj;
            };
            const questionData = this.totalAns.map((question) => {
                const newQuestion = JSON.parse(JSON.stringify(question));
                if (newQuestion.question_type_id == '24') {
                    delete newQuestion.editor_context;
                    newQuestion.subQuestions = newQuestion.subQuestions.map(subQ => removeKeys(subQ));
                } else {
                    removeKeys(newQuestion);
                }
                return newQuestion;
            });
            data = {
                platform: 'web',
                role_id: this.auth.getRoleId(),
                user_id: this.auth.getUserId(),
                student_id: this.auth.getUserId(),
                content_id: this.isTestContent() ? this.getData?.test_content_id : this.questionData.content_id,
                content_format: this.questionData.content_format,
                student_content_id: this.getData.student_content_id,
                class_id: this.getData.class_id,
                overall_student_feedback: this.totalFeedBack,
                content_time_taken,
                all_autograde: this.isSingleQnsWithFeedbackType && this.questionData.auto_review != '0' ? '1' :
                    this.questionData.all_autograde,
                laq_id: this.totalAns[this.showQuestion]?.question_type_id != '24' ?
                    this.totalAns[this.showQuestion]?.question_id : this.totalAns[this.showQuestion]?.subQuestions[0]?.question_id,
                status: id == '4' ? '4' : !checkAllQuestionCorrectedOrNot ? '4' : id,
                questions: questionData
                // questions: this.totalAns
            };
            if (this.isTestContent()) {
                data['is_test'] = this.getData?.is_test;
                data['module_id'] = this.getData?.content_id;
            }

            if (data['status'] == '4') {
                this.inFlightSaveStatus = '4';
                this.setServiceInterval('clear');
            }
        }
        console.log(allow, data , 'allow');
        if (allow || loader) {
            if (isPdfContent) {
                // Original PDF path — no lock release / queue.
                await this.student.submitAnswer(data).subscribe((successData) => {
                        this.submitAnswerSuccess(successData, data, route, loader, questionMove);
                    },
                    (error) => {
                        this.commondata.showLoader(false);
                        this.submitAnswerFailure(error);
                    });
            } else {
                this.student.submitAnswer(data).subscribe((successData) => {
                        this.releaseAnswerRequestLock(data['status'], true);
                        this.submitAnswerSuccess(successData, data, route, loader, questionMove);
                    },
                    (error) => {
                        this.commondata.showLoader(false);
                        this.releaseAnswerRequestLock(data['status'], false);
                        this.submitAnswerFailure(error);
                    });
            }
        } else if (!isPdfContent) {
            this.releaseAnswerRequestLock();
        }

    }

    submitAnswerSuccess(successData, data, route, loader, questionMove) {
        this.commondata.showLoader(false);
        if (successData.IsSuccess) {
            if (this.questionData.answers) {
                this.questionData.answers.forEach((value) => {
                    value.section.forEach((sec) => {
                        sec.sub_questions.forEach((item) => {
                            if (item.answer_attended == '2') {
                                item.answer_attended = '3';
                            }
                        });
                    });
                });
            } else {
                if (data.status != '4') {
                    this.studentAnswerDetails(questionMove, loader);
                }
            }
            this.guard = false;
            this.answerSaving = false;

            if (data.status == '4') {
                this.close();
                this.toastr.success(this.contentType + ' ' + 'Submitted');
            } else if (loader == true && questionMove == 'same') {
                this.toastr.success(this.contentType + ' ' + 'Saved');
            }

            if (this.isTestContent() && data.status == '4') {
                const testDetails = JSON.parse(this.auth.getSessionData('test_details'));
                const contents = testDetails[0]?.contents || [];
                const finishedModuleId = data.module_id;
                if (finishedModuleId == null || finishedModuleId === '') {
                    return;
                }
                // Already loading next module — ignore late/duplicate status-4.
                if (this.pendingNextModule) {
                    return;
                }
                const finishedIndex = contents.findIndex(value => value.content_id == finishedModuleId);
                const currentIndex = contents.findIndex(value => value.content_id == this.getData?.content_id);
                console.log(testDetails, 'test_Details', finishedModuleId, finishedIndex, currentIndex);
                if (finishedIndex < 0 || (currentIndex > -1 && currentIndex > finishedIndex)) {
                    return;
                }

                if (finishedIndex == contents.length - 1) {
                    this.routingOutsideAnsweringPage(route, data);
                } else {
                    this.overallPauseTimer();
                    setTimeout(() => {
                        this.overallTimeTaken = 0;
                    }, 0);
                    this.openTestBreakOrSkip(finishedModuleId);
                }
            } else {
                this.routingOutsideAnsweringPage(route, data);
            }
        } else {
            this.disableButton = false;
        }
    }

    submitAnswerFailure(error) {
        this.answerSaving = false;
        this.disableButton = false;
        if (this.isSingleQnsWithFeedbackType && this.questionData?.auto_review != '0') {
            this.modalRef ? this.modalRef?.close() : '';
        }
        console.log(error);
    }

    // getElapsedTimeIntervalTest(): TimeSpan {
    //     let totalSeconds = this.timeTakenForTestInterval;
    //     if (totalSeconds >= 0) {
    //         let hours: any = 0;
    //         let minutes: any = 0;
    //         let seconds: any = 0;
    //         if (totalSeconds >= 3600) {
    //             hours = Math.floor(totalSeconds / 3600);
    //             totalSeconds -= 3600 * hours;
    //         }
    //
    //         if (totalSeconds >= 60) {
    //             minutes = Math.floor(totalSeconds / 60);
    //             totalSeconds -= 60 * minutes;
    //         }
    //
    //         seconds = totalSeconds;
    //         seconds = seconds <= 9 ? '0' + seconds : seconds;
    //         hours = hours <= 9 ? '0' + hours : hours;
    //         minutes = minutes <= 9 ? '0' + minutes : minutes;
    //         if (this.timeTakenForTestInterval === 0) {
    //             setTimeout(() => {
    //                 this.pauseTimerIntervalOfTest();
    //                 this.skipToNextContent();
    //                 this.timeTakenForTestInterval = 0;
    //             }, 0);
    //         }
    //         return {
    //             hours,
    //             minutes,
    //             seconds
    //         };
    //     }
    // }

    // startTimerIntervalOfTest() {
    //     this.pauseTimerIntervalOfTest();
    //     this.testInterval = setInterval(() => {
    //         this.timeTakenForTestInterval--;
    //         this.testElapsedTime = this.getElapsedTimeIntervalTest();
    //     }, 1000);
    // }

    startTimerIntervalOfTest() {
        this.pauseTimerIntervalOfTest();

        const endTime = Date.now() + this.timeTakenForTestInterval * 1000;

        this.testInterval = setInterval(() => {
            const now = Date.now();
            const remainingSeconds = Math.max(Math.ceil((endTime - now) / 1000), 0);

            this.timeTakenForTestInterval = remainingSeconds;
            this.testElapsedTime = this.getElapsedTimeIntervalTest(remainingSeconds);
            console.log(remainingSeconds, 'remainingSeconds_test');
            if (remainingSeconds <= 0) {
                this.pauseTimerIntervalOfTest();
                this.skipToNextContent();
            }
        }, 1000);
    }

    getElapsedTimeIntervalTest(totalSeconds: number): TimeSpan {
        const hours: any = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;

        const minutes: any = Math.floor(totalSeconds / 60);
        const seconds: any = totalSeconds % 60;

        return {
            hours: hours <= 9 ? '0' + hours : hours,
            minutes: minutes <= 9 ? '0' + minutes : minutes,
            seconds: seconds <= 9 ? '0' + seconds : seconds
        };
    }

    pauseTimerIntervalOfTest() {
        clearInterval(this.testInterval);
        this.testInterval = null;
    }

    skipToNextContent(finishedModuleId?: string | number) {
        if (this.skipModuleTimer || this.pendingNextModule) {
            return;
        }
        const testDetails = JSON.parse(this.auth.getSessionData('test_details'));
        const fromModuleId = finishedModuleId != null && finishedModuleId !== '' ? finishedModuleId
            : this.getData.content_id;
        const findIndex = testDetails[0]?.contents.findIndex(value => value.content_id == fromModuleId);
        const nextModule = testDetails[0]?.contents[findIndex + 1] ?? testDetails[0]?.contents[findIndex];
        this.scheduleTestModuleLoad(nextModule, 'skip');
    }

    routingOutsideAnsweringPage(route, data) {
        if (route == 'exit') {
            this.guard = false;
            this.auth.setSessionData('ContentType', this.contentType);
            if (this.isSingleQnsWithFeedbackType && this.questionData?.auto_review != '0' && data.status == '4') {
                const payload = {
                    content_name: this.contentName,
                    content_id: this.questionData.content_id,
                    content_format: this.questionData.content_format,
                    class_id: this.getData.class_id,
                    student_content_id: this.getData.student_content_id,
                    content_type: this.questionData.content_type
                };
                this.auth.setSessionData('student-card', JSON.stringify(payload));
                this.modalRef ? this.modalRef?.close() : '';
                this.route.navigate(['/studentlogin/score-card']);
            } else {
                this.route.navigate(['/studentlogin/' + this.contentType.toLowerCase()]);
            }
        }
    }

    serviceNeededOrNot(data) {
        const particularObjectValue = data.question_type_id != '24' ? data : data.subQuestions[0];
        if (this.checkAutoGradeQns == '2') {
            return (particularObjectValue.is_correct == '' ||
                (particularObjectValue.is_correct == 'partially-completed' && (particularObjectValue.no_of_attempt < this.maximumAttempt) && this.tryAgainButtonEnabled));
        } else {
            return false;
        }
    }

    serviceNeededOrNotFinalSubmit(data) {
        const particularObjectValue = data.question_type_id != '24' ? data : data.subQuestions[0];
        return (particularObjectValue.is_correct == '' || particularObjectValue.is_correct == 'partially-completed');
    }

    checkCorrectAnswerOrNot(data, questionNeedToCheck) {

        let correctAnswer: any = false;

        if (data.question_type_id == '1') {
            correctAnswer = data.answer.every((items, index) => {
                return !(items.correctActive == '1' && data.given_answer[index].isSelected == '');
            });
        } else if (data.question_type_id == '2') {
            correctAnswer = data.answer.every((items, index) => {
                return !((items.correctActive == '1' && data.given_answer[index].isSelected == '') || (items.correctActive == '' && data.given_answer[index].isSelected != ''));
            });
        } else if (data.question_type_id == '5') {
            correctAnswer = data.given_answer.every((items, index) => {
                return items.isSelected == data.heading_option[index].correctActive.toString();
            });
        } else if (data.question_type_id == '7') {
            let pushArrayValue = [];
            data.given_answer.forEach((item) => {
                const splitedValue = item.isSelected != '' ? item.isSelected.split(',') : [];
                splitedValue.forEach((splitForEach) => {
                    pushArrayValue.push({
                        question : item.options,
                        isSelected: splitForEach
                    });
                });
            });
            const result = pushArrayValue.filter((o1) => {
                return !data.heading_option.some((o2) => {
                    return o1.question == o2.correctOption && o1.isSelected == o2.correctAnswer;
                });
            });
            correctAnswer = pushArrayValue.length == data.heading_option.length && result.length == 0;
        } else if (data.question_type_id == '9') {
            correctAnswer = data.given_answer.every((item) => {
                return !(item.isSelected == '' || item.options[item.isSelected].selected != 'true');
            });
        } else if (data.question_type_id == '10') {
            correctAnswer = data.given_answer.every((items) => {
                const enteredValue = items.options[0]?.value.trim().toLowerCase().split(' ').join('');
                return !(items.isSelected == '' || enteredValue != items.isSelected.trim().toLowerCase().split(' ').join(''));
            });
        } else if (data.question_type_id == '16') {
            correctAnswer = data.answer.every((items, index) => {
                return items.correctAnswer == data.given_answer[index].options;
            });
        } else if (data.question_type_id == '20') {
            if (data.given_answer[0]?.isSelected1) {
                const enteredValue = data.given_answer[0]?.isSelected1.trim().toLowerCase().split(' ').join('');
                // data.answer.forEach((value, index) => {
                //     console.log(value.correctAnswer.trim().toLowerCase().split(' ').join(''), 'mathsss' , index);
                // });
                correctAnswer = data.answer.some(answer => answer.correctAnswer.trim().toLowerCase().split(' ').join('') == enteredValue);
            } else {
                correctAnswer = false;
            }
        }

        if (questionNeedToCheck != 'allQuestion') {
            const particularObjectValue = data.question_type_id != '24' ? data : data.subQuestions[0];
            if ((!correctAnswer && parseInt(particularObjectValue.no_of_attempt) != this.maximumAttempt)) {
                this.correctAnswer = false;
                this.tryAgainButtonEnabled = false;
                correctAnswer = 'partially-completed';
            } else if (correctAnswer) {
                this.correctAnswer = true;
            }
        }
        return correctAnswer.toString();
    }

    studentAnswerDetails(questionMove, loader = true) {
        this.commondata.showLoader(loader);
        this.auth.setSessionData('sse_loader', !loader ? 'true' : 'false');
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            student_content_id: this.getData?.student_content_id,
            question_id: this.totalAns[this.showQuestion]?.question_type_id != '24' ?
                this.totalAns[this.showQuestion]?.question_id : this.totalAns[this.showQuestion]?.subQuestions[0]?.question_id
        };

        this.student.studentAnswer(data).subscribe((successData) => {
                this.studentAnswerDetailsSuccess(successData, questionMove);
            },
            (error) => {
                console.log(error, 'studentAnswerDetails');
                this.commondata.showLoader(false);
            });
    }

    studentAnswerDetailsSuccess(successData, questionMove) {
        // console.log(successData, 'successData');
        this.commondata.showLoader(false);
        this.auth.removeSessionData('sse_loader');
        if (successData.IsSuccess) {
            if (successData.ResponseObject.length != 0) {
                this.percentage = successData.ResponseObject[0]?.percentage;
                if (this.totalAns[this.showQuestion]?.question_type_id == '9' && (successData.ResponseObject[0].is_correct == 'true' ||
                    successData.ResponseObject[0].is_correct == 'false')) {
                    this.cfsPatchDropdown();
                }
                const questionNumber = this.showQuestion;
                if (questionMove == 'next' && successData.ResponseObject[0].is_correct == 'true'){
                    console.log(this.showQuestion, 'first');

                    setTimeout(() => {
                        this.afterSaveFunction(questionNumber);
                    }, 3000);
                } else if (questionMove == 'nextWithNonAutoGraded') {
                    this.afterSaveFunction(questionNumber);
                }
            }
        }
    }

    afterSaveFunction(questionNumber) {
        if (this.totalAns[questionNumber + 1]) {
            this.selectedQuestionList(this.totalAns[questionNumber + 1], questionNumber + 1);
        } else {
            let checkWhetherOtherQuestionCorrectedOrNot = false;
            let indexValue = 0;
            this.totalAns.every((items, index) => {
                const particularObjectValue = items.question_type_id != '24' ? items : items.subQuestions[0];
                if (particularObjectValue.is_correct == '' || particularObjectValue.is_correct == 'partially-completed') {
                    checkWhetherOtherQuestionCorrectedOrNot = true;
                    indexValue = index;
                    return false;
                }
                return true;
            });

            if (checkWhetherOtherQuestionCorrectedOrNot) {
                this.selectedQuestionList(this.totalAns[indexValue], indexValue);
            } else {
                this.guard = false;
                this.route.navigate(['/studentlogin/' + this.contentType.toLowerCase()]);
            }
        }
    }

    previousQuestion() {
        const questionNumber = this.showQuestion;
        this.saveAnswerForFewType(questionNumber, 'save');
        this.showQuestion--;
        this.selectedQuestionList(this.totalAns[this.showQuestion], this.showQuestion);
    }

    checkSubmitFunction() {
        const markedValue = this.totalAns.some(item => item.markedAsReview == true);
        if (markedValue) {
            this.modalRef = this.modalService.open(this.reviewAlert);
        } else {
            this.submitFunction();
        }
    }

    async submitFunction() {
        const particularObjectValue = this.totalAns[this.showQuestion].question_type_id != '24' ? this.totalAns[this.showQuestion] : this.totalAns[this.showQuestion].subQuestions[0];
        if (this.serviceNeededOrNot(particularObjectValue)) {
            const answerValidation = this.checkCorrectAnswerOrNot(particularObjectValue, 'singleQuestion');
            if (answerValidation == 'true' || answerValidation == 'false') {
                this.timeIntervalRunningForTest = true;
                this.buttonClicked = 'submit';
                this.modalRef = this.modalService.open(this.submitAlert);
            } else if (answerValidation == 'partially-completed' && particularObjectValue.no_of_attempt == '2') {
                this.timeIntervalRunningForTest = true;
                this.buttonClicked = 'submit';
                this.modalRef = this.modalService.open(this.submitAlert);
            } else {
                this.pauseTimer();
                this.saveAnswerForFewType(this.showQuestion, 'nextWithAutoGrade');
            }
        } else {
            this.timeIntervalRunningForTest = true;
            this.buttonClicked = 'submit';
            this.modalRef = this.modalService.open(this.submitAlert);
        }
    }

    async checkLastQuestion(currentIndex, lastQuestion) {
        const particularObjectValue = this.totalAns[this.showQuestion].question_type_id != '24' ? this.totalAns[this.showQuestion] : this.totalAns[this.showQuestion].subQuestions[0];
        if (this.serviceNeededOrNot(particularObjectValue) && !this.totalAns[this.showQuestion].markedAsReview) {
            const answerValidation = this.checkCorrectAnswerOrNot(particularObjectValue, 'singleQuestion');
            if (answerValidation == 'true' || answerValidation == 'false') {
                let checkAllQnsCorrectedOrNot = true;
                this.totalAns.every((items, index) => {
                    const particularObjectLoopValue = items.question_type_id != '24' ? items : items.subQuestions[0];
                    if ((particularObjectLoopValue.is_correct == '' || particularObjectLoopValue.is_correct == 'partially-completed') && (currentIndex != index)) {
                        checkAllQnsCorrectedOrNot = false;
                        return false;
                    }
                    return true;
                });
                await setTimeout(() => {
                    checkAllQnsCorrectedOrNot ? this.submitPopup() : this.saveAnswerForFewType(this.showQuestion, 'nextWithAutoGrade');
                }, 0);
            } else {
                this.saveAnswerForFewType(this.showQuestion, 'nextWithAutoGrade');
            }
        } else if (this.checkAutoGradeQns == '0' || this.checkAutoGradeQns == '1' || this.totalAns[this.showQuestion].markedAsReview) {
            this.updateForNonAutoGradedQns(particularObjectValue);
        } else {
            if (lastQuestion) {
                this.totalAns.every((items, index) => {
                    const particularObjectValue = items.question_type_id != '24' ? items : items.subQuestions[0];
                    if (particularObjectValue.is_correct == '' || particularObjectValue.is_correct == 'partially-completed') {
                        this.selectedQuestionList(this.totalAns[index], index);
                        return false;
                    }
                    return true;
                });
            } else {
                this.selectedQuestionList(this.totalAns[currentIndex + 1], currentIndex + 1);
            }
        }
    }

    checkWhetherSaveIsNeeded(data, index, calledFrom) {
        if (this.needSaveForThisQns) {
            this.saveAnswerForFewType(this.selectedIndexForSameQns, 'qnsNumber', index);
        } else {
            this.needSaveForThisQns = this.totalAns[this.showQuestion]?.question_type_id == 10 || this.totalAns[this.showQuestion].question_type_id == '20' || this.totalAns[this.showQuestion].question_type_id == '55' ||
                this.totalAns[this.showQuestion].question_type_id == '40' || this.totalAns[this.showQuestion].question_type_id == '41' ||
                (this.totalAns[this.showQuestion].question_type_id == '24' && this.totalAns[this.showQuestion].subQuestions[0]?.question_type_id == '10');
            this.selectedIndexForSameQns = this.needSaveForThisQns ? this.showQuestion : 0;
            this.selectedQuestionList(data, index, calledFrom);
        }
    }

    saveAnswerForFewType(questionNumber, calledFrom = '', index = 0) {
        if (this.totalAns[questionNumber].question_type_id == '40' || this.totalAns[questionNumber].question_type_id == '41') {
            if (this.totalAns[questionNumber].given_answer[0].isSelected != '' && this.totalAns[questionNumber].given_answer[0].isSelected && (this.graphEdited || calledFrom == 'save')) {
                this.saveGraph(this.totalAns[questionNumber].given_answer[0].isSelected, this.totalAns[questionNumber].editor_key, this.totalAns[questionNumber]);
            }
            this.totalAns[questionNumber].given_answer[0].isSelected = '';
        } else if (['20'].indexOf(this.totalAns[questionNumber].question_type_id) > -1) {
            if (this.totalAns[questionNumber].given_answer[0].isSelected1) {
                this.totalAns[questionNumber].given_answer[0].isSelected = this.totalAns[questionNumber].given_answer[0].isSelected1;
            }
        } else if (this.totalAns[questionNumber].question_type_id == '10') {
            for (let j = 0; j < this.totalAns[questionNumber].given_answer.length; j++) {
                if (this.totalAns[questionNumber].given_answer[j].isSelected1) {
                    this.totalAns[questionNumber].given_answer[j].isSelected = this.totalAns[questionNumber].given_answer[j].isSelected1;
                } else {
                    this.totalAns[questionNumber].given_answer[j].isSelected = '';
                }
            }
        } else if (this.totalAns[questionNumber].question_type_id == '24') {
            for (let j = 0; j < this.totalAns[questionNumber].subQuestions.length; j++) {
                if (this.totalAns[questionNumber].subQuestions[j].question_type_id == '10') {
                    for (let k = 0; k < this.totalAns[questionNumber].subQuestions[j].given_answer.length; k++) {
                        if (this.totalAns[questionNumber].subQuestions[j].given_answer[k].isSelected1) {
                            this.totalAns[questionNumber].subQuestions[j].given_answer[k].isSelected = this.totalAns[questionNumber].subQuestions[j].given_answer[k].isSelected1;
                        } else {
                            this.totalAns[questionNumber].subQuestions[j].given_answer[k].isSelected = '';
                        }
                    }
                }
            }
        }
        if (calledFrom == 'qnsNumber') {
            this.needSaveForThisQns = this.totalAns[index]?.question_type_id == 10 || this.totalAns[index].question_type_id == '20' ||
                this.totalAns[index].question_type_id == '40' || this.totalAns[index].question_type_id == '41' || this.totalAns[index].question_type_id == '55' ||
                (this.totalAns[index].question_type_id == '24' && this.totalAns[index].subQuestions[0]?.question_type_id == '10');
            this.selectedIndexForSameQns = this.needSaveForThisQns ? index : 0;
            this.selectedQuestionList(this.totalAns[index], index);
        } else if (calledFrom == 'nextWithAutoGrade') {
            const particularObjectValue = this.totalAns[this.showQuestion].question_type_id != '24' ? this.totalAns[this.showQuestion] : this.totalAns[this.showQuestion].subQuestions[0];
            this.pauseTimer();
            particularObjectValue.no_of_attempt = parseInt(particularObjectValue.no_of_attempt) + 1;
            particularObjectValue.is_correct = this.checkCorrectAnswerOrNot(particularObjectValue, 'singleQuestion');
            console.log(particularObjectValue.is_correct, 'particularObjectValue.is_correct');
            particularObjectValue.time_taken = this.timeTaken;
            console.log(this.totalAns, 'totalAns');
            this.saveAnswer('2', 'noExit', true, particularObjectValue.is_correct == 'true' ? 'next' : '');
        } else if (calledFrom == 'nextWithNonAutoGraded') {
            const particularObjectValue = this.totalAns[this.showQuestion].question_type_id != '24' ? this.totalAns[this.showQuestion] : this.totalAns[this.showQuestion].subQuestions[0];
            this.pauseTimer();
            particularObjectValue.time_taken = this.timeTaken;
            this.afterSaveFunction(this.showQuestion);
            // this.saveAnswer('2', 'noExit', true, 'nextWithNonAutoGraded');
        }
    }

    // nextQuestion() {
    //
    //     if (this.checkAutoGradeQns == '2' && this.serviceNeededOrNot(this.totalAns[this.showQuestion])) {
    //         document.getElementById('yourTarget').scrollIntoView({
    //             behavior: 'smooth',
    //             block: 'start',
    //             inline: 'start'
    //         });
    //         this.saveAnswer('2', 'noExit', true, 'next');
    //     } else {
    //         const questionNumber = this.showQuestion;
    //         if (this.totalAns[questionNumber + 1]) {
    //             if (this.totalAns[questionNumber]?.question_type_id == '10' || this.totalAns[questionNumber].question_type_id == '20' ||
    //                 this.totalAns[questionNumber].question_type_id == '40' || this.totalAns[questionNumber].question_type_id == '41' || this.totalAns[questionNumber].question_type_id == '55' ||
    //                 (this.totalAns[questionNumber].question_type_id == '24' && this.totalAns[questionNumber].subQuestions[0]?.question_type_id == '10') ) {
    //                 this.saveAnswerForFewType(questionNumber);
    //             } else {
    //                 if (this.checkAutoGradeQns == '0' || this.checkAutoGradeQns == '1') {
    //                     document.getElementById('yourTarget').scrollIntoView({
    //                         behavior: 'smooth',
    //                         block: 'start',
    //                         inline: 'start'
    //                     });
    //                     this.saveAnswer('2', 'noExit', false, 'next');
    //                 } else {
    //                     this.selectedQuestionList(this.totalAns[questionNumber + 1], questionNumber + 1);
    //                 }
    //             }
    //         } else {
    //             let checkWhetherOtherQuestionCorrectedOrNot = true;
    //             let particularIndex = 0;
    //             this.totalAns.every((items, index) => {
    //                 particularIndex = index;
    //                 const particularObjectValue = items.question_type_id != '24' ? items : items.subQuestions[0];
    //                 if (particularObjectValue.is_correct == '' || particularObjectValue.is_correct == 'partially-completed') {
    //                     checkWhetherOtherQuestionCorrectedOrNot = false;
    //                     console.log(particularIndex, 'insideEvery');
    //                     return false;
    //                 }
    //                 return true;
    //             });
    //
    //             console.log(particularIndex, 'outSideEvey');
    //             if (!checkWhetherOtherQuestionCorrectedOrNot) {
    //                 this.selectedQuestionList(this.totalAns[particularIndex], particularIndex);
    //             } else {
    //                 this.guard = false;
    //                 this.route.navigate(['/studentlogin/' + this.contentType.toLowerCase()]);
    //             }
    //         }
    //     }
    // }

    async updateForNonAutoGradedQns(data) {
        let answerEntered = false;
        console.log(data, 'data');
        if (data.is_correct == '') {
            if (data.question_type_id == '1' || data.question_type_id == '2' || data.question_type_id == '5' || data.question_type_id == '7'
                || data.question_type_id == '9') {
                answerEntered = !data.given_answer.every((items) => {
                    return items.isSelected == '';
                });
            } else if (data.question_type_id == '10') {
                data.given_answer.every((items) => {
                    if (items.isSelected1) {
                        if (items.isSelected1.trim() != ''){
                            answerEntered = true;
                            return false;
                        }
                    }
                    return true;
                });
            } else if (data.question_type_id == '16') {
                answerEntered = data.answer_shuffled;
            } else if (['20', '55'].indexOf(data.question_type_id) > -1) {
                answerEntered = !data.given_answer.every((items) => {
                    return items.isSelected1 == '';
                });
            } else if (data.question_type_id == '40' || data.question_type_id == '41') {
                answerEntered = data.answer_valueEmitted;
            }
            data.is_correct = answerEntered && !this.totalAns[this.showQuestion].markedAsReview ? 'manual' : '';
        }
        let checkAllQnsCorrectedOrNot = true;
        this.totalAns.every((items) => {
            const particularObjectLoopValue = items.question_type_id != '24' ? items : items.subQuestions[0];
            if (particularObjectLoopValue.is_correct == '') {
                checkAllQnsCorrectedOrNot = false;
                return false;
            }
            return true;
        });
        this.saveAnswerForFewType(this.showQuestion, 'nextWithNonAutoGraded');

        // await setTimeout(() => {
        //     console.log(checkAllQnsCorrectedOrNot, 'checkAllQnsCorrectedOrNot');
        //     checkAllQnsCorrectedOrNot ? this.submitPopup() : this.saveAnswerForFewType(this.showQuestion, 'nextWithNonAutoGraded');
        // }, 500);

    }

    countClicked(event) {
        event.stopPropagation();
    }

    scoreRelease() {
        console.log(this.questionData, 'questionData');
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            student_id: [this.auth.getUserId()],
            content_id: this.questionData.content_id,
            class_id: this.getData.class_id,
            release_score: '1'
        };
        this.teacher.releaseScore(data).subscribe((successData) => {
                this.releaseScoreSuccess(successData);
            },
            (error) => {
                console.log(error);
            });
    }

    releaseScoreSuccess(successData) {
        if (successData.IsSuccess) {
            console.log(successData, 'release success');
        }
    }

    saveAnnotation() {
        const data = {
            platform: 'web',
            student_id: this.auth.getUserId(),
            annotation: this.areaInfo,
            content_id: this.getData.content_id,
            student_content_id: this.getData.student_content_id,
            class_id: this.getData.class_id,
        };
        this.creator.saveAnnotation(data).subscribe((successData) => {
                this.saveAnnotationSuccess(successData);
            },
            (error) => {
                this.saveAnnotationFailure(error);
            });
    }

    saveAnnotationSuccess(successData) {
    }

    saveAnnotationFailure(error) {
        console.log(error);
    }

    setting() {
        const data = {
            platform: 'web',
            type: 'list',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
        };
        this.common.settingsDetails(data).subscribe((successData) => {
                this.listSuccess(successData);
            },
            (error) => {
                console.log(error);
            });
    }

    listSuccess(successData) {
        if (successData.IsSuccess) {
            this.settingList = successData.ResponseObject;
            this.settingList.forEach((val) => {
                if (val.name == 'answer_key_upload' && val.value == '1') {
                    this.showUploadFile = true;
                } else if (val.name == 'answer_key_upload' && val.value == '0') {
                    this.showUploadFile = false;
                }
                if (val.name == 'file_size_restriction') {
                    this.uploadFileSize = val.value;
                }
            });
        }
    }

    encodePdfFileAsURL(event: any) {
        console.log('service called 2');
        const images = [];
        console.log(event.target.files, 'event.target.files');
        const imageLength = event.target.files.length;
        for (let i = 0; i < event.target.files.length; i++) {
            const getUrlEdu = '';
            const pdfDetails = event.target.files[i];
            const reader = new FileReader();
            reader.onload = (event: any) => {
                const uploadTypeList = event.target.result.split(',');
                images.push({
                    image: uploadTypeList[1],
                    size: pdfDetails.size,
                    type: pdfDetails.type,
                    name: pdfDetails.name
                });
                const pic = pdfDetails.type.split('/');
                if (pic[1] == 'pdf') {
                    if (imageLength == images.length) {
                        if (this.uploadFileSize != 0) {
                            const bytes = images[0].size;
                            const mb = bytes / (1024 * 1024);
                            if (mb <= this.uploadFileSize) {
                                this.onUploadKYCFinishedpdf(images);
                            } else {
                                const limit = 'Upload PDF exceeds limit' + ' (' + this.uploadFileSize.toString() + 'MB' + ')';
                                this.toastr.info(limit);
                            }
                        } else {
                            this.onUploadKYCFinishedpdf(images);
                        }
                    }
                } else {
                    this.toastr.error('PDF are the required file format');
                }
            };
            reader.readAsDataURL(event.target.files[i]);
        }

    }

    onUploadKYCFinishedpdf(getUrlEdu) {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            image_path: getUrlEdu,
            uploadtype: 'offlineanswer'
        };

        this.creator.fileUpload(data).subscribe(
            (successData) => {
                this.pdfuploadSuccess(successData);
            },
            (error) => {
                this.pdfuploadFailure(error);
            }
        );
    }

    pdfuploadSuccess(successData) {
        if (successData.IsSuccess) {
            this.answerPdf = [...this.answerPdf, ...successData.ResponseObject.imagepath];
        }
    }

    pdfuploadFailure(error) {
        console.log(error);
    }

    close() {
        this.timeIntervalRunningForTest = false;
        this.disableButton = false;
        this.modalRef ? this.modalRef?.close() : '';
    }

    closeGraph(id, index) {
        this.totalAns[id].section[index].student_roughdata = this.totalAns[id].section[index].student_roughdata1;
        this.modalRef1.close();
    }

    backbutton() {
        console.log(this.contentType, 'contentType');
        if (this.contentType == 'Assessment') {
            this.route.navigate(['/studentlogin/assessment']);
        } else {
            this.route.navigate(['/studentlogin/assignment']);
        }
    }

    onSave() {
        this.modalRef.close();
    }

    otherlink() {
        this.modalRef = this.modalService.open(this.link);
    }

    openWorkArea(item, i, j) {
        if (item != '') {
            this.workAnnotate = [...item.workarea];
        }
        this.workAreaId = i;
        this.workAreaIndex = j;
        document.body.style.overflow = 'hidden !important';
        this.cdr.detectChanges();
        console.log(document.body.style.overflow, 'overflow');
        this.modalRef = this.modalService.open(this.workArea, {size: 'xl', backdrop: 'static'});
    }

    getWorkAreaAnnotation(event) {
        console.log(event, 'workAnnotateVlaue');
        this.workAnnotate = event;
        console.log(this.workAnnotate, 'work annotate');
    }

    closeWorkArea() {
        let i = this.workAreaId;
        let j = this.workAreaIndex;
        if (this.totalAns[i].section[j].workarea !== this.workAnnotate) {
            this.totalAns[i].section[j].workarea = [...this.workAnnotate];
            this.totalAns[i].section[j].answer_attended = '1';
        }
        this.close();
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    selectedQuestionList(data, index, calledFrom?) {
        console.log(data, 'datas');
        this.pauseTimer();
        this.timeTaken = 0;
        this.correctAnswer = true;
        this.tryAgainButtonEnabled = false;
        this.showQuestion = index;
        const particularObjectValue = data.question_type_id != '24' ? data : data.subQuestions[0];
        if (this.getData.student_content_status == '1' || this.getData.student_content_status == '2') {
            if (particularObjectValue.time_taken == '0') {
                this.timeTaken = 0;
                this.startTimer();
            } else {
                this.timeTaken = particularObjectValue.time_taken;
                if (this.checkAutoGradeQns != '2') {
                    this.startTimer();
                } else {
                    const checkCondition = this.checkQuestionId(this.totalAns[this.showQuestion])?.is_correct == '' && !this.tryAgainButtonEnabled;
                    if (checkCondition) {
                        this.startTimer();
                    }
                }
                if (particularObjectValue.question_type_id == '9' && particularObjectValue.is_correct != 'partially-completed') {
                    this.cfsPatchDropdown();
                }
            }
        } else {
            this.timeTaken = particularObjectValue.time_taken != '0' && particularObjectValue.time_taken != '' && particularObjectValue.time_taken
                ? particularObjectValue.time_taken : 0;
        }
        this.cdr.detectChanges();
        this.clickEvent();
        if (calledFrom != 'questionList') {
            document.getElementById('yourTarget').scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'start'
            });
        }
        console.log(this.showQuestion, 'showQuestion');
    }

    getFeedBackList() {
        this.auth.setSessionData('sse_loader', 'true');
        const payload = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            student_content_id: this.getData.student_content_id,
            school_id: this.auth.getSessionData('school_id'),
        };
        this.auth.postService(payload, urls.getOverallFeedback).subscribe((successData: any) => {
            if (successData.IsSuccess) {
                this.auth.setSessionData('sse_loader', 'false');
                this.feedbackListData = successData.IsSuccess ? successData.ResponseObject : [];
            }
        });
    }

    getFeedbackLabel(feedback: any): { label: string } {
        if (feedback.student_score >= 30) {
            return { label: 'Exceptional'};
        } else if (feedback.student_score > 20 && feedback.student_score <= 29) {
            return { label: 'Good'};
        } else {
            return { label: 'Improve'};
        }
    }

    clearFeedBackTimer() {
        if (this.feedBackTimer) {
            this.loadingCompleted = true;
            this.progress = 100;
            clearInterval(this.feedBackTimer);
        }
    }

    getFeedbackValue(data, calledType = '') {
        if (data.given_answer[0]?.isSelected.trimStart() != '') {
            if ((data.given_answer[0]?.isSelected.trim().split(/\s+/).length >= this.minimumWordValidation) || this.minimumWordValidation == 0) {
                this.overallPauseTimer();
                this.pauseTimer();
                if (calledType != '') {
                    this.modalRef ? this.modalRef?.close() : '';
                    // this.popUpMessage = 'Please be patient as we provide the final score and feedback.';
                    // this.startFeedBackTimer();
                    this.startFakeProgress();
                    // this.modalRef = this.modalService.open(this.feedbackStatus , {backdrop : 'static'});
                    this.totalAns[0].earned_points = this.previousFeedBack[0]?.student_score;
                    this.totalAns[0].points = this.previousFeedBack[0]?.total_score;
                    this.totalAns[0].time_taken = this.overallTimeTaken;
                    this.buttonClicked = '';
                    this.saveAnswer('4', 'exit', false);
                } else {
                    this.startFakeProgress();
                    // this.popUpMessage = calledType == '' ? 'Nice work. Please wait while we provide a feedback' :
                    //     'Please wait while we provide a final feedback and score.';
                    // this.startFeedBackTimer();
                    // this.modalRef = this.modalService.open(this.feedbackStatus , {backdrop : 'static'});
                    // this.convertedText = '';
                    const payload = {
                        platform: 'web',
                        role_id: this.auth.getRoleId(),
                        user_id: this.auth.getUserId(),
                        school_id: this.auth.getSessionData('school_id'),
                        student_id: this.auth.getUserId(),
                        student_answer: data.given_answer[0]?.isSelected,
                        question_id: data.question_id,
                        question: this.stripHtmlTags(data.question),
                        student_content_id: this.getData.student_content_id,
                        time_taken: this.timeTaken,
                        finalSubmit: '0'
                        // finalSubmit: calledType == 'saveAndExit' ? '1' : '0'
                    };
                    this.student.getOpenAiFeedback(payload).subscribe((successData: any) => {
                        console.log(successData, 'successData');
                        if (successData.IsSuccess) {
                            this.selectedPreviousStudentAnswer = successData.ResponseObject[0];
                            this.totalAns[0].earned_points = successData.ResponseObject[0]?.student_score;
                            this.totalAns[0].points = successData.ResponseObject[0]?.total_score;
                            this.totalAns[0].time_taken = this.overallTimeTaken;
                            this.reviseSelected = '';
                            if (this.selectedPreviousStudentAnswer.version != 'V1') {
                                this.convertedText = successData.ResponseObject[0]?.feedback;
                                // this.updateFeedback();
                            } else {
                                this.convertedText = this.convertMarkdownToHtml(successData.ResponseObject[0]?.feedback);
                                // this.scrollToFeedBack();
                            }
                            this.feedbackServiceCalled = true;
                            this.getFeedbackCount(data);
                        } else {
                            // this.convertedText = '';
                            this.disableButton = false;
                            this.overAllStartTimer();
                            // calledType == '' ? this.modalRef.close() : this.commondata.showLoader(false);
                            this.clearFeedBackTimer();
                            // this.modalRef ? this.modalRef?.close() : '';
                            this.toastr.error(successData.ErrorObject);
                        }
                    }, (error) => {
                        this.overAllStartTimer();
                        console.error(error, 'error_feedbackValue');
                        // this.convertedText = '';
                        this.disableButton = false;
                        // calledType == '' ? this.modalRef.close() : this.commondata.showLoader(false);
                        this.clearFeedBackTimer();
                        // this.modalRef.close();
                        this.toastr.error('Server Error, Please Contact admin');
                    });
                }
                // calledType != '' ? this.modalRef.close() : '';
            } else {
                this.toastr.error('Answer should be at least ' + this.minimumWordValidation + ' words.');
            }
        } else {
            this.toastr.error('Answer Should not be empty');
        }
    }

    getValue(value: string): string {
        if (!value) return '';
        const parts = value.split('_');
        const formatted = parts.map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
        return formatted;
    }

    updateFeedback(calledFrom = '') {
        this.feedbackList = this.getUpdatedConvertedFeedback(this.convertedText);
        console.log(this.feedbackList, 'feedback')
        this.totalScore = this.feedbackList.length * this.totalIndivialScore;
        this.score = 0;
        setTimeout(() => {
            this.feedbackList.forEach(feedback => {
                this.score = this.score + feedback[1]?.score;
                feedback.collaspsed = true;
            });
        }, 500);
        // calledFrom == '' ? this.scrollToFeedBack() : '';
        this.versionComparsionBarChart();
    }

    // scrollToFeedBack() {
    //     setTimeout(() => {
    //         document.getElementById('feedback_got').scrollIntoView({
    //             behavior: 'smooth',
    //             block: 'start',
    //             inline: 'start'
    //         });
    //     }, 0);
    // }

    undoRevise(value) {
        this.totalAns[0].given_answer[0].isSelected = value.student_answer;
        this.overallPauseTimer();
        this.feedbackSelected(value);
    }

    feedbackSelected(value, calledFrom = '') {
        const selectedValue = value;
        if (value != '' && value != 'current') {
            this.selectedFeedBackIndex = this.previousFeedBack.length - selectedValue.index;
            this.selectedVersion = value.index;
            this.selectedPreviousStudentAnswer = selectedValue;
            if (this.selectedPreviousStudentAnswer.version != 'V1') {
                this.convertedText = selectedValue?.feedback;
                this.updateFeedback(calledFrom);
            } else {
                this.convertedText = this.convertMarkdownToHtml(selectedValue.feedback);
            }
            this.reviseSelected = '';
            this.overallPauseTimer();
            this.pauseTimer();
        } else if (value == 'current'){
            // this.selectedFeedBackIndex = '';
            // this.convertedText = '';
            this.selectedVersion = 0;
            this.reviseSelected = 'current';
            document.getElementById('essay_textarea').scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'start'
            });
            this.selectedFeedBackIndex = this.previousFeedBack.length - 1;
            this.selectedPreviousStudentAnswer = this.previousFeedBack[0];
            if (this.selectedPreviousStudentAnswer.version != 'V1') {
                this.convertedText = this.previousFeedBack[0]?.feedback;
                this.updateFeedback(calledFrom);
            } else {
                this.convertedText = this.convertMarkdownToHtml(this.previousFeedBack[0]?.feedback);
            }
            this.overAllStartTimer();
            this.startTimer();
        }
        this.feedbackServiceCalled = false;
    }

    getUpdatedConvertedFeedback(value) {
        return Object.entries(value);
    }

    versionComparsionBarChart() {
        const seriesData = this.feedbackList.map((items) => {
            return {name: items[0], categories: this.getValue(items[0]), score: items[1]?.score ?? 0};
        });
        const previousFeedback = this.selectedFeedBackIndex == '' ? this.totalFeedBackCount - 1 :
            this.selectedFeedBackIndex == 1 ? this.previousFeedBack.length - 1 : this.selectedPreviousStudentAnswer.index + 1;
        let previousSeriesData = [];
        if (this.selectedFeedBackIndex != '' && this.selectedFeedBackIndex != 1) {
            const previousFeedBackList = this.getUpdatedConvertedFeedback(this.previousFeedBack[previousFeedback]?.feedback);
            previousSeriesData = previousFeedBackList.map((items: any) => {
                return {score: items[1]?.score ?? 0};
            });
        } else {
            seriesData.map(value => value.score).forEach(items => {
                previousSeriesData.push({score: 0});
            });
        }
        console.log(previousSeriesData, 'previousSeriesData');
        console.log(seriesData, 'seriesData');
        this.chartOptions = {
            series: [
                {
                    name: 'Current Version',
                    data: seriesData.map(value => value.score)
                },
                {
                    name: 'Previous Version',
                    data: previousSeriesData.map(value => value.score)
                }
            ],
            chart: {
                type: 'bar',
                height: 300,
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '40%'
                }
            },
            dataLabels: {
                enabled: true
            },
            xaxis: {
                categories: seriesData.map(value => value.categories)
            },
            yaxis: {
                min: 0,
                max: 5,
                tickAmount: 5,
                labels: {
                    formatter: val => val.toFixed(0)
                }
            },
            legend: {
                position: 'bottom'
            }
        };
    }

    getFeedbackCount(data, calledFrom = '') {
        const payload = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            student_id: this.auth.getUserId(),
            question_id: data.question_id,
            student_content_id: this.getData.student_content_id,
        };
        this.student.getOpenAiFeedbackCount(payload).subscribe((successData) => {
            this.getFeedbackCountSuccess(successData, calledFrom);
        }, (error) => console.error(error, 'error_APICount'));
    }

    getFeedbackCountSuccess(successData, calledFrom) {
        console.log(successData, 'successData');
        if (successData.IsSuccess) {
            successData.ResponseObject.forEach((items, index) => {
                items.index = index;
                items.version_name = 'Version' + ' ' + (successData.ResponseObject.length - index);
            });
            this.previousFeedBack = successData.ResponseObject;
            this.totalFeedBackCount = successData.count ?? 0;
            // this.selectedFeedBackIndex = calledFrom != '' ? '' : successData.count;
            this.selectedFeedBackIndex = successData.count;
            console.log(this.selectedFeedBackIndex, 'selectedFeedBackIndex_count');
            if (calledFrom != '' && successData.ResponseObject.length != 0) {
                if (['1', '2'].includes(this.getData.student_content_status)) {
                    this.overallElapsedTime = this.getElapsedOverAllTime(this.overallTimeTaken);
                }
                this.feedbackSelected(successData.ResponseObject[0], calledFrom);
            } else if (calledFrom == '' && this.selectedPreviousStudentAnswer.version != 'V1') {
                this.selectedPreviousStudentAnswer.index = 0;
                this.toastr.success('New Feedback updated');
                this.clearFeedBackTimer();
                // this.modalRef ? this.modalRef?.close() : '';
                this.updateFeedback();
            } else if (calledFrom != ''  && successData.ResponseObject.length == 0) {
                this.overAllStartTimer();
            }
            console.log(this.previousFeedBack, 'previous');
            if (calledFrom == '') {
                this.getFeedBackList();
            }
        } else {
            this.toastr.error('Server error. Please Contact admin');
        }
    }

    stripHtmlTags(input: string): string {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = input;
        return tempDiv.textContent || tempDiv.innerText || '';
    }

    toggleCalculator() {
        this.showCalculator = !this.showCalculator;
        setTimeout(() => {
            if (this.showCalculator) {
                const elt = document.getElementById('calculator');
                if (elt) {
                    this.calculator = Desmos.GraphingCalculator(elt);
                    this.calculator.setExpression({ id: 'graph1', latex: '' });
                }
            }
        }, 0);
    }

    public onScroll(): void {
        const left = this.scrollContent.nativeElement.scrollLeft;
        const sWidth = this.scrollContent.nativeElement.scrollWidth;
        const oWidth = this.scrollContent.nativeElement.offsetWidth;
        // Left arrow
        if (left === 0) {
            this.hideArrow(this.leftArrow);
        } else {
            this.showArrow(this.leftArrow);
        }
        // Right arrow
        const total = oWidth + left;
        if (total >= sWidth) {
            this.hideArrow(this.rightArrow);
        } else {
            this.showArrow(this.rightArrow);
        }
    }

    public onClickScrollRight(): void {
        this.scrollTo('+', this.distance);
    }

    public onClickScrollLeft(): void {
        this.scrollTo('-', this.distance);
    }

    private showArrow(arrow: ElementRef): void {
        arrow.nativeElement.classList.remove('hide');
    }

    private hideArrow(arrow: ElementRef): void {
        arrow.nativeElement.className += ' hide';
    }

    private scrollTo(operator: string, distance: number): void {
        const operators = {
            '+': (a, b) => {
                return a + b;
            },
            '-': (a, b) => {
                return a - b;
            },
        };
        const op = operators[operator];
        this.scrollContent.nativeElement.scrollTo(
            {
                left: op(this.scrollContent.nativeElement.scrollLeft, distance),
                behavior: 'smooth'
            });
    }

    getTestDetails() {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            content_id: this.getData.content_id,
            student_content_id: this.getData.student_content_id,
            school_id: this.auth.getSessionData('school_id')
        };
        this.creator.testDetail(data).subscribe((successData) => {
                this.testSuccess(successData);
            },
            (error) => {
                console.error(error, 'error_lisDetails');
            });
    }

    testSuccess(successData) {
        if (successData.IsSuccess) {
            successData.ResponseObject[0]?.contents.forEach(item => item.name = item.subject + ' - ' + item.module_name);
            this.testFullData = successData.ResponseObject[0];
            this.testContentDetail = successData.ResponseObject[0].contents;
            this.testContentData = this.testContentDetail[0]?.content_id;
            this.questionList(this.testContentDetail[0]);
        }
    }

    startFakeProgress() {
        this.loadingCompleted = false;
        this.feedBackTimer = setInterval(() => {
            if (this.progress < 95) {
                this.progress += Math.random() * 1.6;
                if (this.progress > 95) {
                    this.progress = 95;
                }
            }
        }, 300);
    }

    startFeedBackTimer() {
        this.totalSeconds = 60;
        this.secondsLeft = this.totalSeconds;
        this.dashOffset = 0;

        this.feedBackTimer = setInterval(() => {

            const elapsed = this.totalSeconds - this.secondsLeft;
            const progress = elapsed / this.totalSeconds;

            this.dashOffset = this.circumference * progress;

            this.secondsLeft--;

            if (this.secondsLeft < 0) {
                this.secondsLeft = this.totalSeconds;
                this.dashOffset = 0;
            }

        }, 1000);
    }

}

interface Position {
    x: number;
    y: number;
}

interface Rectangle {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    d: string;
    text: any;
    width: number;
    height: number;
}

interface AreaInfo {
    rectangleId: string;
    pageNumber: number;
    rect: Rectangle;
    isDelete?: boolean;
    isTeacherCorrection?: boolean;
    shape: string;
    color: any;
    fontSize: any;
}
